import React, { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import { sendPaymentForm_action } from "../../../actions/payment_action/payment_action";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import { BASE_URL, DOC_BASE_URL, attendeeTypeActionId, cityActionId, countryActionId, exhibitorBadgeDaysActionId, visitDaysPricingActionId, industryChaptersActionId, paymentPortalLink, pincodeActionId, primaryChapterListActionId, surchargeListActionId, seminarInterestActionId, stateActionId, educationRoleTypeActionId, toastError, toastSuccess, visitPurposeActionId, visitorInterestActionId, visitorTypeListActionId } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action"
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Resizer from "react-image-file-resizer";
import { data } from "jquery";
import { combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, deleteVisaDoc_action } from "../../../actions/visitor_module_action/visitor_form_action/visitor_form_action"
import { emailValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import { getVisitorRegistrationCredentials_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { payment_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getVisitorPreviewDetails_action, visitorPreviewSubmit_action, verifyVisitorPromoCode_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action";
import VisitorHeader from "../../../common_components/visitor_module_header";
import ConfirmationModal from "../../../common_components/confirmationa_modal";


class Visitor_Preview extends Component {

    // Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOtherPreName: false,
            isSameAsMobNo: false,
            isDisplayStateList: false,
            isDisplayCityList: false,
            isDisplayPincodeList: false,
            needVisaAssistance: false,
            isDisplayPassCountryList: false,
            isAgree: false,
            isVisaApplied: false,
            isOpen: false,
            isOpen2: false,
            isPassportFilePresent: "",
            isVisaUpdated: false,
            isGrpDelegation: false,
            isDisplayDelegationCountryList: false,
            isInterstOne: false,
            isInterestTwo: false,
            isParkingChargable: false,
            isCarParking: 0,
            parkingCharges: 0,
            isParkingAvailable: false,
            visitorCharges: 0,
            promoCodeDiscount: 0,
            totaltaxable: 0,
            seminarCharges: 0,
            isPromoApply: false,
            promoCode: "",
            paymentAccessCode: 'AVVI64IL27CE56IVEC',
            encPayload: '',
            isPaid: false,

            // Fields 
            country: "",
            countryId: "",
            attendeeType: "",
            attendeeTypeId: "",
            otherName: "",
            preName: "",
            firstName: "",
            middleName: "",
            lastName: "",
            designation: "",
            institute: "",
            preMobNo: "",
            mobNo: "",
            preWhatsAppMobNo: "",
            whatsAppMobNo: "",
            regState: "",
            city: "",
            pincode: "",
            website: "",
            email: "",
            preTelNo: "",
            telNo: "",
            preTel1No: "",
            tel1No: "",
            passName: "",
            preApplicantMobNo: "",
            applicantMobNo: "",
            applicantEmail: "",
            passNo: "",
            visitorGroupList: [],
            passDate: "",
            passExipryDate: "",
            passCountryId: "",
            passCountry: "",
            passportFile: "",
            remarks: "",
            passPortFileName: "",
            passportFileType: "",
            leader: "",
            delegationCountry: "",
            delegationCountryId: "",
            arrivalDate: "",
            departureDate: "",
            delegationRemark: "",
            preffDate: "",
            prefTime: "",
            b2bRemark: "",
            visitorTypeList: [],
            // Lists
            countryList: [],
            attendeeList: [],
            daysList: [],
            stateList: [],
            tempStateList: [],
            cityList: [],
            tempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            level1: [],
            visitPurposeList: [],
            passCountryList: [],
            tempPassCountryList: [],
            interestList: [],
            industryChapterList: [],
            delgationCountryList: [],
            tempDelegationCountryList: [],
            zIndexseminarInterestList: [],
            primaryChapterListData: [],
            level0: [],
            level1: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel2: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            GroupDetailsList: [],
            VisitorTypeID: '',
            // Err Messages
            attendeeTypeErr: "",
            daysErr: "",
            firstNameErr: "",
            designationErr: "",
            instituteErr: "",
            mobNoErr: "",
            whatsAppMobNoErr: "",
            regStateErr: "",
            cityErr: "",
            pincodeErr: "",
            chapterErr: "",
            visitPurposeErr: "",
            passNameErr: "",
            applicantMobNoErr: "",
            applicantEmailErr: "",
            passNoErr: "",
            passDateErr: "",
            passExipryDateErr: "",
            passCountryErr: "",
            passportFileErr: "",
            leaderErr: "",
            delegationCountryErr: "",
            arrivalDateErr: "",
            departureDateErr: "",
            delegationRemarkErr: "",
            preffDateErr: "",
            preffTimeErr: "",
            b2bRemarkErr: "",
            ChapterHallErr: "",
            paymentLink: '',
            educationRoleTypeList: [],
            educationRoleTypeId: '',
            educationRoleTypeIdErr: '',
            educationRoleTypeIdModal: '',
            educationRoleTypeIdErrModal: '',
            eduRoleName: '',

            remark: '',
            toPay: '',
            paymentMasterList: [],
            isPaymentEnable: false,
            scripts: [],

            CGST: 0,
            SGST: 0,
            IGST: 0,
            totalCharges: 0,
            toShow: 0,
            isInvoice: '',
            INVPersonName: '',
            INVCompanyName: '',
            INVAddress: '',
            INVTanNo: '',
            GSTNo: '',
            PANNo: '',

            INVPersonNameErr: '',
            INVCompanyNameErr: '',
            INVAddressErr: '',
            INVTanNoErr: '',
            GSTNoErr: '',
            PANNoErr: '',
            PIID: '',
            promocodeModel: false,
            discountpercent: '',
            countryIdINV: '',
            pincodeINV: '',
            regStateINV: '',
            cityINV: '',
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isOpen4: false,
            pgViewChargesModal: false,
            pgViewChargesFillList: [],
            isSurchargeForceOpen: true,
            isForeignVisitorPop: false,
            conversionRate: '',
            isPaidByUSD: true,
            pgViewAddChargesModal: false,
            additionalChargesUSDper: 0,
            additionalChargesUSD: 0,
            isOpen5: false
        }
        this.submitfrm = React.createRef()
        this.getFillList = this.getFillList.bind(this)
        this.onAttendeeSelect = this.onAttendeeSelect.bind(this)
        this.onSelectDates = this.onSelectDates.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onSelectPrimaryChapter = this.onSelectPrimaryChapter.bind(this)
        this.onPassportCountrySearch = this.onPassportCountrySearch.bind(this)
        this.renderPassCountryList = this.renderPassCountryList.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.onPreviewSubmit = this.onPreviewSubmit.bind(this)
        this.getVisitorRegistrationDetails = this.getVisitorRegistrationDetails.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onSelectPurpose = this.onSelectPurpose.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.getVisitorCredentials = this.getVisitorCredentials.bind(this)
        this.getDrawerDetails = this.getDrawerDetails.bind(this)
        this.otherDetailsChange = this.otherDetailsChange.bind(this)
        this.onDelegationCountrySearch = this.onDelegationCountrySearch.bind(this)
        this.renderDelegationCountryList = this.renderDelegationCountryList.bind(this)
        this.handlePrefTime = this.handlePrefTime.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.onFileClick = this.onFileClick.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.navToPayment = this.navToPayment.bind(this)
        this.record = this.record.bind(this)
        this.onCheckLevel1 = this.onCheckLevel1.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.recordTwo = this.recordTwo.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordThree = this.recordThree.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.onApplyPromo = this.onApplyPromo.bind(this)
        this.onCancelPromo = this.onCancelPromo.bind(this)
        this.onPrevClick = this.onPrevClick.bind(this)
        this.renderGroupList = this.renderGroupList.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.togglePGCharges = this.togglePGCharges.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onPreviewSubmit(popArg[0])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    // On Component Load 
    componentDidMount() {

        this.callGAScripts()
        window.scrollTo(0, 0)
        console.log((sessionStorage.getItem('VisitorDataSS')))
        // Country List 
        this.getFillList(countryActionId, '', '', '', '', '').then(() => {
            this.getFillList(visitorInterestActionId, '', '', '', '', '').then(() => {
                // Attendee List
                this.getFillList(attendeeTypeActionId, '', '', '', '', '').then(() => {
                    // Days List Action
                    this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "").then(() => {
                        this.getFillList(pincodeActionId, '', '', '', '', '').then(() => {
                            this.getFillList(stateActionId, '', '', '', '', '').then(() => {
                                this.getFillList(cityActionId, '', '', '', '', '').then(() => {
                                    this.getFillList(primaryChapterListActionId, '', '', '', '', '').then(() => {
                                        this.getFillList(industryChaptersActionId, '', '', '', '', '').then(() => {
                                            this.getFillList(visitPurposeActionId, '', '', '', '', '').then(() => {
                                                this.getFillList(educationRoleTypeActionId, '', '', '', '', '').then(() => {

                                                    this.getFillList(visitPurposeActionId, '', '', '', '', '').then(() => {
                                                        this.getFillList(seminarInterestActionId, '', '', '', '', '').then(() => {
                                                            this.getFillList(visitorTypeListActionId, '', '', '', '', '').then(() => {
                                                                this.getFillList(visitDaysPricingActionId, '', '', '', '', '').then(() => {
                                                                    this.getDrawerDetails()
                                                                    // this.getVisitorCredentials()
                                                                    setTimeout(() => {
                                                                        this.getFillList(surchargeListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                                                                        // then(() => {
                                                                        this.getVisitorRegistrationDetails()
                                                                        // })
                                                                    }, 200);
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })

                                })
                            })
                        })
                    })
                })
            })
        })

        // Calling City , State , Pincode filllist on country Select

        // Primary Chapters
        // Industry Chapters
        // Visit Purpose List 
        // Visitor Interest List 
        // Visitor Interest List 


        // Calling Get Visitor Details
        setTimeout(() => {
            if (sessionStorage.getItem('promoCode') != null && sessionStorage.getItem('promoCode') != '') {
                this.setState({
                    promoCode: sessionStorage.getItem('promoCode'),
                    isPromoApply: true
                })
            }
        }, 500);

        if (this.props.params != null && (this.props.params.status == "Failure" || this.props.params.status == "Invalid")) {
            toast.error('There is some problem. Please try again later!', {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
        }


    }
    togglePGCharges(mode) {
        const { scripts, GroupDetailsList, countryId, isForeignVisitorPop } = this.state
        if (mode != 2) {
            if (sessionStorage.getItem("VisitorTypeID") == 1) {
                if (countryId != 91) {
                    this.setState({ isForeignVisitorPop: true })
                    return
                }
            } else {
                for (var i = 0; i < GroupDetailsList.length; i++) {
                    if (GroupDetailsList[i].CountryName.trim().toLowerCase() != 'india') {
                        this.setState({ isForeignVisitorPop: true })
                        return
                    }
                }
            }
        }
        if (countryId == 91) {
            this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        } else {
            this.setState({ pgViewAddChargesModal: !this.state.pgViewAddChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        }
    }
    componentWillUnmount() {
        // Cleanup: Remove scripts when component unmounts
        const { scripts } = this.state
        if (scripts) {
            scripts.forEach((script) => {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            });
        }
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    // Get Drawer Details
    getDrawerDetails() {
        this.setState({ isLoading: true })
        this.props.getDrawerDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getDrawerDetails", data.data)
                    sessionStorage.setItem("sessionVisitorDrawerData", JSON.stringify(data.data))

                    // Formatting Address
                    var address = data.data[0] != null && data.data[0] != "" && data.data[0]['Address'] != null && data.data[0]['Address'] != "" &&
                        data.data[0]['Address']
                    var addArray = address != "" && address != null && address.split(",")
                    sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray))

                    // Formating Mobile Numbers
                    var mobNo = data.data[0] != null && data.data[0] != "" && data.data[0]['MobileNo'] != null && data.data[0]['MobileNo'] != "" &&
                        data.data[0]['MobileNo']
                    var MobArray = mobNo != "" && mobNo != null && mobNo.split(",")
                    sessionStorage.setItem("FormatedMobNo", JSON.stringify(MobArray))
                    // this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // Get Exhibitior Details
    getVisitorCredentials() {
        console.log("Get JSON.parse(sessionStorage.getItem('loginDataSS')).UserIDJSON.parse(sessionStorage.getItem('loginDataSS')).UserIDJSON.parse(sessionStorage.getItem('loginDataSS')).UserID", JSON.parse(sessionStorage.getItem('VisitorDataSS')))

        this.setState({ isLoading: true })
        this.props.getVisitorRegistrationCredentials_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getVisitorCredentials", data.data[0])
                    sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0]))
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        return new Promise((resolve, reject) => {

            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data != null ? data.data : [],
                                passCountryList: data != null ? data.data : [],
                                tempPassCountryList: data != null ? data.data : [],
                                delgationCountryList: data != null ? data.data : [],
                                tempDelegationCountryList: data != null ? data.data : [],
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === surchargeListActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                pgViewChargesFillList: data.data, isLoading: false,
                            })
                            // data.data.length > 0 && data.data.map(item => {
                            //     item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                            // })
                        }
                        // state list
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitorTypeListActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                visitorTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === educationRoleTypeActionId) {
                            console.log("educationRoleTypeActionId data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                educationRoleTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        // Days List
                        if (actionID === exhibitorBadgeDaysActionId) {
                            console.log("exhibitor data", data.data)
                            var DateList = []
                            var DateListModal = []
                            // data.data.map(item => {
                            //     DateList.push(item)
                            // })
                            // data.data.map(item => {
                            //     DateListModal.push(item)
                            // })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                DateList.push(mapData)
                                // DateListModal.push(mapData)
                            })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                // DateList.push(mapData)
                                DateListModal.push(mapData)
                            })
                            this.setState({
                                daysList: DateList,
                                daysModalList: DateListModal,
                                isLoading: false,
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            // sessionStorage.setItem("isExhibitionFree", JSON.stringify(data.data[0]['isExhibitionFree']))
                            resolve(true)
                        }
                        if (actionID === visitDaysPricingActionId) {
                            console.log("exhibitor data", data.data)
                            this.setState({
                                // daysList: DateList,
                                pricingList: data.data
                                // daysModalList: DateListModal,
                                // isLoading: false,
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            this.setState({
                                isExhibitionFree: data.data.length == 0,
                            })
                            sessionStorage.setItem("isExhibitionFree", data.data.length == 0)
                            resolve(true)

                        }
                        // Attendee Type List
                        if (actionID === attendeeTypeActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                attendeeList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        //Chapter List
                        if (actionID === primaryChapterListActionId) {
                            console.log("primaryChapterListActionId 121212", data.data)
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],
                                isLoading: false,
                            })
                            setTimeout(() => {
                                this.setState({
                                    // isLoading: false,
                                })
                            }, 3000);
                            resolve(true)
                        }
                        // Industry Chapter List
                        if (actionID === industryChaptersActionId) {
                            console.log("industryChaptersActionId 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.IsSelect = false
                            })
                            this.setState({
                                industryChapterList: data.data,
                            })
                            setTimeout(() => {
                                this.setState({
                                    // isLoading: false,
                                })
                            }, 3000);
                            resolve(true)
                        }
                        // Visit Purpose list
                        if (actionID === visitPurposeActionId) {
                            console.log(" Visit Purpose List data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                                item.otherDetail = ""
                            })
                            this.setState({
                                visitPurposeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        //Visitor Interest List
                        if (actionID === visitorInterestActionId) {
                            // console.log("Visitor Interest List 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                            })
                            this.setState({
                                interestList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                            console.log(this.state.interestList, ';;', data.data)

                        }
                        //Visitor Semninar Interest List
                        if (actionID === seminarInterestActionId) {
                            console.log("Visitor Interest List 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                            })
                            this.setState({
                                seminarInterestList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })

    }

    // Input Fields Validation
    inputValidate() {
        const { attendeeTypeId, daysList, designation, institute, mobNo, whatsAppMobNo, regState, countryId, city, pincode, level1,
            visitPurposeList, needVisaAssistance, passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate,
            passCountryId, passportFile, isGrpDelegation, leader, delegationCountryId, arrivalDate, departureDate, delegationRemark,
            industryChapterList, isInterestTwo, educationRoleTypeId, prefTime, preffDate, b2bRemark, primaryChapterListData, level2, level3, level4 } = this.state
        if (attendeeTypeId == "") {
            this.setState({ attendeeTypeErr: "Please Select Attendee Type" });
        } else {
            if (attendeeTypeId == 3) {
                if (educationRoleTypeId == '') {
                    this.setState({ educationRoleTypeIdErr: "Please Select Education Role Type" });
                }
            }
        }
        if (!(daysList.some(obj => obj.isSelect == true))) {
            this.setState({ daysErr: "Please Select Days" })
        }
        if (designation == "") {
            this.setState({ designationErr: "Please enter designation" });
        }
        if (institute == "") {
            this.setState({ instituteErr: "Please enter institue/Organization" });
        }
        if (mobNo == "") {
            this.setState({ mobNoErr: "Please enter mobile no" });
        }
        if (whatsAppMobNo == "") {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
        }
        if (regState == "" && countryId == "91") {
            this.setState({ regStateErr: "Please enter province/state" });
        }
        if (city == "") {
            this.setState({ cityErr: "Please enter city" });
        }
        if (pincode == "") {
            this.setState({ pincodeErr: "Please enter Pincode" });
        }
        if (!(industryChapterList.some(obj => obj.IsSelect == true))) {
            this.setState({ chapterErr: "Please Select Industry segment" })
        }
        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
        if (!(filerArray.some(obj => obj.IsSelect == true))) {
            this.setState({ ChapterHallErr: "Please Select Hall" })
        }
        if (!(visitPurposeList.some(obj => obj.isSelect == true))) {
            this.setState({ visitPurposeErr: "Please Select Purpose of visit" })
        }
        // Visa assistance validation
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
            }
            if (passCountryId == "") {
                this.setState({ passCountryErr: "Please Select Country " });
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    return
                }
            }
        }
        else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: ""
            })
        }
        if (isGrpDelegation) {
            if (leader == "") {
                this.setState({ leaderErr: "Please enter Leader/Organisation" });
            }
            if (delegationCountryId == "") {
                this.setState({ delegationCountryErr: "Please enter Country" });
            }
            if (arrivalDate == "") {
                this.setState({ arrivalDateErr: "Please enter Arrival Date" });
            }
            if (departureDate == "") {
                this.setState({ departureDateErr: "Please enter Departure Date" });
            }
            if (delegationRemark == "") {
                this.setState({ delegationRemarkErr: "Please enter Delegation Remark" });
            }
        }
        else {
            this.setState({
                leaderErr: "",
                delegationCountryErr: "",
                arrivalDateErr: "",
                departureDateErr: "",
                delegationRemarkErr: "",
            })
        }
        if (isInterestTwo) {
            if (preffDate == "") {
                this.setState({ preffDateErr: "Please enter Preffered Date" });
            }
            if (prefTime == "") {
                this.setState({ preffTimeErr: "Please enter Preffered Time" });
            }
        } else {
            this.setState({
                preffTimeErr: "", preffTimeErr: ""
            })
        }

    }

    // On Select Attendee 
    onAttendeeSelect(e) {
        const { attendeeList } = this.state
        var checked = e.target.checked
        var id = e.target.value
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (checked) {
                if (id == data.AttendeeTypeID) {
                    data.isChecked = true
                    this.setState({ attendeeTypeId: data.AttendeeTypeID, attendeeTypeErr: "" })
                } else {
                    data.isChecked = false
                }
            } else {
                data.isChecked = false
            }
        })
        this.setState({ attendeeList: attendeeList })
    }

    // On Select Dates
    onSelectDates(e) {
        const { daysList } = this.state
        var code = e.target.value
        var checked = e.target.checked
        daysList.length > 0 && daysList.map((data) => {
            if (checked) {
                if (code == data.Code) {
                    data.isSelect = true
                }
            } else {
                if (code == data.Code) {
                    data.isSelect = false
                }

            }
        })
        console.log("hgdddhdjdjdjdkdj", daysList)
        this.setState({ daysList: daysList, daysErr: "" })
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    // On Same As Mobile No Click
    onSameAsMobNoClick(e) {
        const { isSameAsMobNo, mobNo, preMobNo } = this.state
        this.setState({ isSameAsMobNo: !isSameAsMobNo })
        var checked = e.target.checked
        if (checked) {
            this.setState({
                whatsAppMobNo: mobNo,
                preWhatsAppMobNo: preMobNo,
                whatsAppMobNoErr: ""
            })
        } else {
            this.setState({
                whatsAppMobNo: "",

            })

        }
    }

    // search state
    onStateSearch(e) {
        const { tempStateList, stateList } = this.state
        if (e.target.value != '') {
            var searchStateList = tempStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                regState: e.target.value,
                regStateErr: "",
                tempStateList: searchStateList,
                isDisplayStateList: true
            })
        } else {
            this.setState({
                regState: e.target.value,
                tempStateList: stateList,
                isDisplayStateList: false
            })
        }
    }

    // render state
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regState: data.Description, isDisplayStateList: false })}
                        >{data.Description}</li>

                    ))
                }
            </ul>
        )
    }

    // search city
    onCitySearch(e) {
        const { cityList, tempCityList } = this.state
        if (e.target.value != '') {
            var searchCityList = tempCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                city: e.target.value,
                cityErr: "",
                tempCityList: searchCityList,
                isDisplayCityList: true
            })
        } else {
            this.setState({
                city: e.target.value,
                tempCityList: cityList,
                isDisplayCityList: false
            })
        }
    }

    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    //Pincode Search
    onPincodeSearch(e) {
        const { pincodeList, tempPincodeList, pincode } = this.state
        if (e.target.value != '') {
            var searchPincodeList = tempPincodeList.filter(data => {
                return (
                    data
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                pincode: e.target.value,
                pincodeErr: "",
                tempPincodeList: searchPincodeList,
                isDisplayPincodeList: true
            })
        } else {
            this.setState({
                pincode: e.target.value,
                tempPincodeList: pincodeList,
                isDisplayPincodeList: false
            })
        }
    }

    // render pincode
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                pincode: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    // On Primary Chapter Select
    onSelectPrimaryChapter(e) {
        const { industryChapterList } = this.state
        var id = e.target.value
        var checked = e.target.checked

        industryChapterList.length > 0 && industryChapterList.map((data) => {
            if (checked) {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = true
                }
            }
            else {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = false
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", industryChapterList)
        this.setState({ industryChapterList: industryChapterList, chapterErr: "" })
    }

    // On Purpose Select
    onSelectPurpose(e) {
        const { visitPurposeList } = this.state
        var code = e.target.value
        var checked = e.target.checked

        visitPurposeList.length > 0 && visitPurposeList.map((data) => {
            if (checked) {
                if (code == data.PurposeofVisitID) {
                    data.isSelect = true

                }
            }
            else {
                if (code == data.PurposeofVisitID) {
                    data.isSelect = false
                    data.otherDetail = ""
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", visitPurposeList)
        this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: "" })
    }

    // On PassPort Country Search
    onPassportCountrySearch(e) {
        const { passCountryList, tempPassCountryList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempPassCountryList ++++----------->", tempPassCountryList)

            var searchCoutryList = tempPassCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                passCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                passCountryErr: '',
                tempPassCountryList: searchCoutryList,
                isDisplayPassCountryList: true,
                isVisaUpdated: true
            })
        }
        else {

            this.setState({
                passCountry: e.target.value,
                tempPassCountryList: passCountryList,
                isDisplayPassCountryList: false
            })
        }
    }

    // Render Country for PassPort Country
    renderPassCountryList() {
        const { tempPassCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPassCountryList.length > 0 && tempPassCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                passCountry: data.Description, passCountryId: data.Code,
                                isDisplayPassCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On File Pick
    onFilePick = async (e, file, key) => {
        e.preventDefault()
        console.log("File01010101------", file, key)
        const { } = this.state
        this.setState({ isVisaUpdated: true })
        if (file[0]['size'] >= 5 * 1024 * 1024) {
            console.log("consdition1111111111111111111")
            toastError('File size more than 5mb are not allow.')
            if (key == 1) {
                this.setState({ passportFile: "" })
                document.getElementById("passportFile").value = ""
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        } else {
            var image = '';
            if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                file[0]['name'].toString().toLowerCase().includes('.png') ||
                file[0]['name'].toString().toLowerCase().includes('.jpg')
            ) {
                if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                    file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                ) {
                    image = await this.resizeFile(file[0]);
                    if (key == 1) {
                        this.setState({ passportFile: image, passportFileErr: "" })

                    } else if (key == 2) {
                        this.setState({ visitorLetterFile: image })
                    }
                }
                else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                    image = await this.onPdfSelect(file[0]);
                    if (key == 1) {
                        this.setState({ passportFile: image, passportFileErr: "" })
                    } else if (key == 2) {
                        this.setState({ visitorLetterFile: image })
                    }
                }

                var fileType = file[0]['type']
                var fileTypeList;
                if (fileType.includes("/")) {
                    fileTypeList = fileType.split("/")
                }
                if (key == 1) {
                    this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else if (key == 2) {
                    this.setState({ visitorLetterFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                }
            } else {
                toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                if (key == 1) {
                    this.setState({ passportFile: "" })
                    document.getElementById("passportFile").value = ""
                } else if (key == 2) {
                    this.setState({ visitorLetterFile: "" })
                    document.getElementById("visitorLetter").value = ""
                }
            }
        }
    }

    // on Cross click
    onCrossClick(key) {
        const { passportFileType, isPassportFilePresent, passportFile } = this.state
        if (isPassportFilePresent) {
            const { isOpen } = this.state
            this.setState({ isOpen: !isOpen })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            if (key == 1) {
                this.setState({ passportFile: "" })
                document.getElementById("passportFile").value = ""
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
    }

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // On Select Interests
    onSelectInterest(e) {
        const { interestList } = this.state
        var code = e.target.value
        var checked = e.target.checked

        interestList.length > 0 && interestList.map((data) => {
            if (checked) {
                if (code == data.AreaofInterestID) {
                    data.isSelect = true
                    if (code == 1) {
                        this.setState({
                            isInterstOne: true
                        })
                    } else if (code == 2) {
                        this.setState({ isInterestTwo: true })
                    }
                }
            }
            else {
                data.isSelect = false
                if (code == 1) {
                    this.setState({
                        isInterstOne: false
                    })
                } else if (code == 2) {
                    this.setState({ isInterestTwo: false })
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", interestList)
        this.setState({ interestList: interestList })
    }

    // On Preview Submit Click
    onPreviewSubmit(e) {
        e.preventDefault()
        const { visitorCharges, isCarParking, totalCharges, isPaymentEnable, parkingCharges, promoCodeDiscount, promoCode } = this.state
        // const totalCharges = visitorCharges + (isCarParking ? parkingCharges : 0) - promoCodeDiscount
        this.setState({ isLoading: true })
        this.props.visitorPreviewSubmit_action(totalCharges, promoCode)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, PIID: data.data.length > 0 && data.data[6] != undefined && data.data[6].length > 0 && data.data[6][0] != undefined && data.data[6][0].ProformaInvoiceID != undefined ? data.data[6][0].ProformaInvoiceID : '' }, () => {
                        // toastSuccess("Visitor Submitted Successfully")
                        if (!JSON.parse(sessionStorage.getItem("isExhibitionFree")) && totalCharges > 0) {
                            this.navToPayment()
                        } else {
                            this.props.navigate('/visitorthankyou')
                        }
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Nav To Payment
    navToPayment() {
        const { parkingCharges, countryId, remark, visitorCharges, isCarParking, promoCodeDiscount, toPay, totalCharges } = this.state
        // const totalCharges = visitorCharges + (isCarParking ? parkingCharges : 0) - promoCodeDiscount

        var cancel_url = `${BASE_URL}/visitor/paymentResponse`
        var redirect_url = `${BASE_URL}/visitor/paymentResponse`;//need to ask to redirect

        var request = {
            order_id: `${JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID}`,
            currency: `${countryId == 91 ? 'INR' : 'USD'}`,
            amount: `${totalCharges}`,
            redirect_url: `${redirect_url}`,
            cancel_url: `${redirect_url}`,
            merchant_param1: `${'1'}`,
            language: `EN`
        }

        var mapData = {
            'orderParams': request
        }

        // this.props.payment_action(mapData)
        //     .then((data) => {
        //         if (data != null) {
        //             console.log("payment response : ", data)
        //             this.setState({ encPayload: data.data })
        //             setTimeout(() => {
        //                 console.log("submit form", this.submitfrm)
        //                 this.submitfrm.current.submit()
        //                 // this.props.navigate('/payment', { state: { encPayload: this.state.encPayload, } })
        //             }, 1000);
        //         } else {
        //             this.setState({ isLoading: false })
        //             toast.error('There is some problem. Please try again later!', {
        //                 theme: 'colored',
        //                 autoClose: 3000,
        //                 hideProgressBar: true,
        //             })
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err)
        //     })
        var moreInfo = null
        this.setState({ isLoading: true })

        this.props.sendPaymentForm_action(sessionStorage.getItem("sessionExhibitionID"),
            JSON.parse(sessionStorage.getItem('VisitorTypeID')) == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorIDs : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID,
            countryId == 91 ? totalCharges : this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2),
            countryId == 91 ? 'INR' : this.state.isPaidByUSD ? 'USD' : 'INR', [{ ProformaInvoiceID: this.state.PIID }], 'visitorRegistration', moreInfo, remark, JSON.parse(sessionStorage.getItem('VisitorTypeID')) == 2 ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('VisitorDataSS')).AccountID, JSON.parse(sessionStorage.getItem('VisitorTypeID')) == 2 ? JSON.parse(sessionStorage.getItem("VisitorDataSS")).VisitorRegistrationNos.split(',')[0] : JSON.parse(sessionStorage.getItem("VisitorDataSS")).VisitorRegistrationNo, countryId == 91 ? false : this.state.isPaidByUSD)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data != null) {
                        console.log("payment response : ", data)

                        // this.setState({ encPayload: data.data }, () => {
                        //     this.submitfrm.current.submit()
                        // })
                        this.setState({ paymentLink: data.data }, () => {
                            // this.submitfrm.current.submit()
                            // window.open(data.data, '_blank')
                            window.location.replace(data.data)

                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError('There is some problem. Please try again later!')
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Get Visitor Registration Details
    getVisitorRegistrationDetails() {
        // setTimeout(() => {
        const { attendeeList, daysList, industryChapterList, educationRoleTypeId, visitPurposeList, interestList, seminarInterestList, primaryChapterListData,
            level2, level3, level4 } = this.state
        console.log(interestList, ';;')
        this.setState({ isLoading: true })
        this.props.getVisitorPreviewDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    // this.getFillList(visitPurposeActionId, '', '', '', '', '')
                    console.log("getVisitorRegistrationDetails", data.data['registrationDetails'][0])
                    // Updating Attendee List
                    var attendeeId = data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : ''
                    attendeeList.length > 0 && attendeeList.map((item) => {
                        if (item.AttendeeTypeID == attendeeId) {
                            item.isChecked = true
                        }
                    })
                    // Days List Prepare on basis on get Days list
                    var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                    daysList.length > 0 && daysList.map((item) => {
                        selectedDaysList.length > 0 && selectedDaysList.map((element) => {
                            if (element.VisitDate == item.VisitDate) {
                                item.isSelect = true
                            }
                        })
                    })
                    var pay = 0
                    var promoAvailable = false
                    if (data.data['registrationDetails'].length == 1) {

                        if (data.data['registrationDetails'][0].CountryID == 91) {
                            for (var i = 0; i < daysList.length; i++) {
                                if (daysList[i].isSelect) {
                                    if (daysList[i].PriceINR != null && daysList[i].PriceINR != '') {
                                        pay = pay + daysList[i].PriceINR
                                    }
                                }
                            }
                        } else {
                            for (var i = 0; i < daysList.length; i++) {
                                if (daysList[i].isSelect) {
                                    if (daysList[i].PriceUSD != null && daysList[i].PriceUSD != '') {
                                        pay = pay + daysList[i].PriceUSD
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < daysList.length; i++) {
                            if (daysList[i].PromoCode != null && daysList[i].PromoCode != '') {
                                promoAvailable = true
                                break
                            }
                        }
                    }
                    console.log(pay, 'dayas', daysList)

                    var obj = {}
                    var indexx = ''
                    data.data['registrationDetails'].length > 1 &&
                        data.data['registrationDetails'].map((item, i) => {
                            console.log(item)
                            if (item.isCoordinator) {
                                obj = item
                                indexx = i
                                // data.data['registrationDetails'].spl
                            }
                        })
                    if (Object.keys(obj).length != 0) {
                        // console.log("The object is empty.");
                        data.data['registrationDetails'].splice(indexx, 1)
                        data.data['registrationDetails'].unshift(obj)
                    }
                    // Split Phone Numbers and country Code 
                    //  Mobile No
                    var mob1 = data.data['registrationDetails'][0]['MobileNo']
                    const parts = mob1.split("-");
                    const Mob1Code = parts[0]
                    const Mob1No = parts[1]
                    // WhatsApp Mobile No
                    var mob2 = data.data['registrationDetails'][0]['WhatsappNo']
                    const parts2 = mob2.split("-")
                    const Mob2Code = parts2[0]
                    const Mob2No = parts2[1]
                    // TelePhone No
                    var tel = data.data['registrationDetails'][0]['Telephone']
                    const parts3 = tel.split("-")
                    const telCode = parts3[0]
                    const telNumber = parts3[1]
                    // Telephone 1 Mobile No
                    var tel1 = data.data['registrationDetails'][0]['Telephone1']
                    const parts4 = tel1.split("-")
                    const tel1Code = parts4[0]
                    const tel1Number = parts4[1]
                    data.data['registrationDetails'].length > 1 ?
                        this.setState({ VisitorTypeID: 2 }) : this.setState({ VisitorTypeID: 1 })
                    data.data['registrationDetails'].length > 1 &&
                        data.data['registrationDetails'].map((item, i) => {
                            var daysArr = []
                            var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                            daysList.length > 0 && daysList.map((element) => {
                                selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                    if (element2.ExhVisitorID == item.ExhVisitorID) {
                                        if (element2.VisitDate == element.VisitDate) {
                                            console.log(element2.ExhVisitorID, item.ExhVisitorID, element.VisitDate, 'elementelementelementelement')
                                            element.isSelect = true
                                            daysArr.push(element)
                                        }
                                    }
                                })
                            })
                            console.log('--------------', daysList, daysArr)
                            if (item.CountryID == 91) {
                                for (var i = 0; i < daysArr.length; i++) {
                                    if (daysArr[i].isSelect) {
                                        if (daysArr[i].PriceINR != null && daysArr[i].PriceINR != '') {
                                            pay = pay + daysArr[i].PriceINR
                                        }
                                    }
                                }
                            } else {
                                for (var i = 0; i < daysArr.length; i++) {
                                    if (daysArr[i].isSelect) {
                                        if (daysArr[i].PriceUSD != null && daysArr[i].PriceUSD != '') {
                                            pay = pay + daysArr[i].PriceUSD
                                        }
                                    }
                                }
                            }
                            for (var i = 0; i < daysArr.length; i++) {
                                if (daysArr[i].PromoCode != null && daysArr[i].PromoCode != '') {
                                    promoAvailable = true
                                    break
                                }
                            }

                            var chapterList = []
                            // Chapter List Prepare on basis on get Days list
                            var selectedChapters = data.data['chapterList'] != null ? data.data['chapterList'] : []
                            industryChapterList.length > 0 && industryChapterList.map((element) => {
                                selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                    if (element2.ExhVisitorID == item.ExhVisitorID) {
                                        if (element2.ChapterID == element.IndustrySegmentID) {
                                            item.IsSelect = true
                                            chapterList.push(element)
                                        }
                                    }
                                })
                            })

                            var hallList = []
                            var SelectedHallChapters = data.data['hallChapterList'] != null ? data.data['hallChapterList'] : []
                            primaryChapterListData.length > 0 && primaryChapterListData.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingExhVisitorID == item.ExhVisitorID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            item.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level2.length > 0 && level2.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingExhVisitorID == item.ExhVisitorID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            item.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level3.length > 0 && level3.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingExhVisitorID == item.ExhVisitorID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            item.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level4.length > 0 && level4.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingExhVisitorID == item.ExhVisitorID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            item.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })

                            var seminarInterestListData = []
                            var selectedSeminarList = data.data['seminarInterestList'] != null ? data.data['seminarInterestList'] : []
                            console.log(selectedSeminarList, 'selectedSeminarList')
                            selectedSeminarList.map((item2) => {
                                console.log('seminarInterestListseminarInterestList', item2.ExhvisitorID, item.ExhVisitorID)
                                if (item2.ExhvisitorID == item.ExhVisitorID) {
                                    var data = {
                                        "SeminarID": item2.SeminarID,
                                    }
                                    seminarInterestListData.push(data)
                                }

                            })

                            var isInterestTwo = false
                            var isInterstOne = false
                            var selectedInterestList = []
                            // selectedInterestList.length > 0 && selectedInterestList.map(element => {
                            //     if (element.AreaofInterestID == 2) {
                            //         if (item.B2BDepartureDate != '' && item.B2BDepartureDate != null && item.B2BPreferredTime != '' && item.B2BPreferredTime != null && item.B2BRemark != '' && item.B2BRemark != null) {
                            //             element.status = true
                            //             element.isSelect = true
                            //             // isInterestTwo = true
                            //         }
                            //     }
                            //     if (element.AreaofInterestID == 1) {
                            //         if (seminarInterestListData.length > 0) {
                            //             element.status = true
                            //             element.isSelect = true
                            //             // isInterstOne = true
                            //         }
                            //     }
                            // })
                            if (item.IsInterestedforb2b) {
                                isInterestTwo = true
                                selectedInterestList.push({ 'AreaofInterestID': 2 })
                            }
                            if (item.IsInterestedforSeminar) {
                                selectedInterestList.push({ 'AreaofInterestID': 1 })
                                isInterstOne = true
                            }
                            var isShowIntrestList = false
                            if (isInterestTwo || isInterstOne) {
                                isShowIntrestList = true
                            }
                            setTimeout(() => {
                                console.log(isShowIntrestList, isInterstOne, isInterestTwo)
                            }, 1000);

                            // var mob1 = item['MobileNo']
                            // const parts = mob1.split("-");
                            // const Mob1Code = parts[0]
                            // const Mob1No = parts[1]
                            // // WhatsApp Mobile No
                            // var mob2 = item['WhatsappNo']
                            // const parts2 = mob2.split("-")
                            // const Mob2Code = parts2[0]
                            // const Mob2No = parts2[1]
                            // // TelePhone No
                            // var tel = item['Telephone']
                            // const parts3 = tel.split("-")
                            // const telCode = parts3[0]
                            // const telNumber = parts3[1]
                            // // Telephone 1 Mobile No
                            // var tel1 = item['Telephone1']
                            // const parts4 = tel1.split("-")
                            // const tel1Code = parts4[0]
                            // const tel1Number = parts4[1]

                            var mob1 = item['MobileNo']
                            const parts = mob1.split("-");
                            const Mob1Code = parts.length == 2 ? parts[0] : ''
                            const Mob1No = parts.length == 2 ? parts[1] : mob1
                            // WhatsApp Mobile No
                            var mob2 = item['WhatsappNo']
                            const parts2 = mob2.split("-")
                            const Mob2Code = parts2.length == 2 ? parts2[0] : ''
                            const Mob2No = parts2.length == 2 ? parts2[1] : mob2

                            // TelePhone No
                            var tel = item['Telephone']
                            const parts3 = tel.split("-")
                            const telCode = parts3.length == 2 ? parts3[0] : ''
                            const telNumber = parts3.length == 2 ? parts3[1] : tel
                            // Telephone 1 Mobile No
                            var tel1 = item['Telephone1']
                            const parts4 = tel1.split("-")
                            const tel1Code = parts4.length == 2 ? parts4[0] : ''
                            const tel1Number = parts4.length == 2 ? parts4[1] : tel1
                            var obj = {
                                'Title': item.Title ? item.Title : '',
                                'firstName': item.FirstName ? item.FirstName : '',
                                'middleName': item.MiddleName ? item.MiddleName : '',
                                'lastName': item.LastName ? item.LastName : '',
                                'institute': item.Institute_Organisation ? item.Institute_Organisation : '',
                                'isOtherPreName': '',
                                'otherName': '',
                                'B2BDepartureDate': item.B2BDepartureDate != '' && item.B2BDepartureDate != null ? new Date(item.B2BDepartureDate) : null,
                                'B2BPreferredTime': item.B2BPreferredTime != '' && item.B2BPreferredTime != null ? (item.B2BPreferredTime) : null,
                                'B2BRemark': item.B2BRemark != '' && item.B2BRemark != null ? (item.B2BRemark) : null,
                                'designation': item.Designation ? item.Designation : '',
                                'mobNo': Mob1No ? Mob1Code ? `${Mob1Code}-${Mob1No}` : Mob1No : '',
                                'whatsAppMobNo': Mob2No ? Mob2Code ? `${Mob2Code}-${Mob2No}` : Mob2No : '',
                                'pincode': item.Pincode ? item.Pincode : '',
                                'regState': item.State ? item.State : '',
                                'isSameAsMobNo': item.IsSameAsMobileNo ? item.IsSameAsMobileNo : '',
                                'city': item.City ? item.City : '',
                                'website': item.Website ? item.Website : '',
                                'AccountID': item.AccountID ? item.AccountID : '',
                                'educationRoleTypeId': item.EducationRoleTypeID ? item.EducationRoleTypeID : '',
                                'eduRoleName': item.EducationRoleTypeName ? item.EducationRoleTypeName : '',
                                'identityCardPath': item.IdentityCardPath != null && item.IdentityCardPath != '' ? `${DOC_BASE_URL}${item.IdentityCardPath}` : '',
                                'ExhVisitorID': item.ExhVisitorID ? item.ExhVisitorID : '',
                                'email': item.Email ? item.Email : '',
                                'isCoordinator': item.isCoordinator ? item.isCoordinator : false,
                                'isVisit': item.isVisit ? item.isVisit : false,
                                'Telephone': telNumber ? telCode ? `${telCode}-${telNumber}` : telNumber : '',
                                'Telephone1': tel1Number ? tel1Code ? `${tel1Code}-${tel1Number}` : tel1Number : '',
                                'id': i + 1,
                                'CountryName': item.CountryName,
                                'DateList': daysArr,
                                'chapterArr': chapterList,
                                'hallList': hallList,
                                'seminarList': seminarInterestListData,
                                'isShowIntrestList': isShowIntrestList,
                                'isInterestTwo': isInterestTwo,
                                'isInterstOne': isInterstOne,
                                'selectedInterestList': selectedInterestList
                            }
                            this.state.GroupDetailsList.push(obj)
                        })
                    console.log('obj', this.state.GroupDetailsList)

                    if (data.data['registrationDetails'].length > 1) {
                        // data.data['registrationDetails'].length > 1 ? sessionStorage.setItem('VisitorTypeID', 2) : sessionStorage.setItem('VisitorTypeID', 1)
                        data.data['registrationDetails'].length > 1 &&
                            data.data['registrationDetails'].map((item, i) => {
                                var obj = { 'AccountID': '', 'VisitorRegistrationNo': '', 'visitorID': '', 'passName': '', 'passExipryDateErr': '', 'passNameErr': '', 'preApplicantMobNo': '', 'applicantMobNo': '', 'applicantMobNoErr': '', 'applicantEmail': '', 'applicantEmailErr': '', 'passNo': '', 'passNoErr': '', 'passDate': '', 'passDateErr': '', 'passExipryDate': '', 'passCountry': '', 'passCountryId': '', 'passCountryErr': '', 'isPassportFilePresent': '', 'passportFileErr': '', 'passportFile': '', 'passportFilePath': '', 'isDisplayPassCountryList': '', 'passportFileType': '', 'isCoordinator': '', 'isVisit': '', 'leader': '', 'delegationCountryId': '', 'delegationCountry': '', 'arrivalDate': '', 'departureDate': '', 'delegationRemark': '', 'isGrpDelegation': item.IsGroupDelegation, 'isVisaAssistance': item.isVisaAssistance }
                                if (item.isVisaAssistance != null && item.isVisaAssistance != '' && item.isVisaAssistance != false) {
                                    var mob5 = item['ApplicantMobileNo']
                                    const parts5 = mob5.split("-")
                                    const Mob5Code = parts5.length == 2 ? parts5[0] : ''
                                    const Mob5No = parts5.length == 2 ? parts5[1] : mob5
                                    var email = item.ApplicantEmailID
                                    var filePath = item.PassportFilePath != null ? item['PassportFilePath'] : ''
                                    var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" && filePath.split("/")
                                    const FileName = array[array.length - 1]

                                    obj.AccountID = item.AccountID

                                    obj.VisitorRegistrationNo = item.VisitorRegistrationNo
                                    obj.visitorID = item.ExhVisitorID
                                    obj.passName = item.NameOnPassport
                                    obj.passExipryDateErr = ''
                                    obj.passNameErr = ''
                                    obj.preApplicantMobNo = Mob5Code
                                    obj.applicantMobNo = Mob5No
                                    obj.applicantMobNoErr = ''
                                    obj.applicantEmail = email
                                    obj.applicantEmailErr = ''
                                    obj.passNo = item.PassportNo
                                    obj.passNoErr = ''
                                    obj.passDate = new Date(item.PassportIssueDate)
                                    obj.passDateErr = ''
                                    obj.passExipryDate = new Date(item.PassportExpiryDate)
                                    obj.passCountry = item.PassportIssuingCountryName
                                    obj.passCountryId = item.PassportIssuingCountryID
                                    obj.passCountryErr = ''
                                    obj.isPassportFilePresent = true
                                    obj.passportFileErr = ''
                                    obj.passportFile = FileName
                                    obj.passportFilePath = item.PassportFilePath
                                    obj.isDisplayPassCountryList = false
                                    obj.passportFileType = ''
                                    obj.isCoordinator = item.isCoordinator
                                    obj.isVisit = item.isVisit
                                    // finalArr.push(obj)

                                }
                                if (item.IsGroupDelegation != null && item.IsGroupDelegation != '' && item.IsGroupDelegation != false) {

                                    obj.leader = item.DelegationName
                                    obj.delegationCountryId = item.DelegationCountryID
                                    obj.delegationCountry = item.DelegationCountryName
                                    obj.arrivalDate = new Date(item.DelegationArrivalDate)
                                    obj.departureDate = new Date(item.DelegationDepartureDate)
                                    obj.delegationRemark = item.DelegationRemark

                                }
                                this.state.visitorGroupList.push(obj)
                                // this.state.GroupDetailsList.push(obj)
                            })
                    }

                    // Chapter List Prepare on basis on get Days list
                    var selectedChapters = data.data['chapterList'] != null ? data.data['chapterList'] : []
                    industryChapterList.length > 0 && industryChapterList.map((item) => {
                        selectedChapters.length > 0 && selectedChapters.map((element) => {
                            if (element.ChapterID == item.IndustrySegmentID) {
                                item.IsSelect = true
                            }
                        })
                    })
                    // Hall Chapter List prepare 
                    var SelectedHallChapters = data.data['hallChapterList'] != null ? data.data['hallChapterList'] : []
                    primaryChapterListData.length > 0 && primaryChapterListData.map((item) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                            if (element.MappingChapterID == item.ChapterID) {
                                item.IsSelect = true
                            }
                        })
                    })
                    level2.length > 0 && level2.map((item) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                            if (element.MappingChapterID == item.ChapterID) {
                                item.IsSelect = true
                            }
                        })
                    })
                    level3.length > 0 && level3.map((item) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                            if (element.MappingChapterID == item.ChapterID) {
                                item.IsSelect = true
                            }
                        })
                    })
                    level4.length > 0 && level4.map((item) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                            if (element.MappingChapterID == item.ChapterID) {
                                item.IsSelect = true
                            }
                        })
                    })


                    // visit Purpose List Prepare on basis on get Days list
                    var selectedVisitPurpose = data.data['visitPurposeList'] != null ? data.data['visitPurposeList'] : []
                    visitPurposeList.length > 0 && visitPurposeList.map((item) => {
                        selectedVisitPurpose.length > 0 && selectedVisitPurpose.map((element) => {
                            if (element.PurposeofVisitID == item.PurposeofVisitID) {
                                item.isSelect = true
                                item.otherDetail = element.OtherDetails
                            }
                        })
                    })
                    // Applicant Mobile No
                    var appMobNo = data.data['registrationDetails'][0]['ApplicantMobileNo']
                    var parts5 = '';
                    var appMobCode = '';
                    var appMobileNo = '';
                    if (appMobNo != null && appMobNo != '') {
                        parts5 = appMobNo.includes('-') && appMobNo.split("-")
                        appMobCode = parts5[0]
                        appMobileNo = parts5[1]
                    }

                    // Area Of Interest  List Prepare on basis on get Days list
                    var selectedInterest = data.data['areaOfInterestList'] != null ? data.data['areaOfInterestList'] : []
                    interestList.length > 0 && interestList.map((item) => {
                        selectedInterest.length > 0 && selectedInterest.map((element) => {
                            if (element.AreaofInterestID == 1) {
                                this.setState({ isInterstOne: true })
                            } else if (element.AreaofInterestID == 2) {
                                this.setState({ isInterestTwo: true })
                            }
                            if (element.AreaofInterestID == item.AreaofInterestID) {
                                item.isSelect = true
                            }
                        })
                    })
                    console.log('selectedInterestselectedInterest', selectedInterest)

                    // if (data.data['registrationDetails'].length == 1) {
                    //     interestList.length > 0 && interestList.map((item) => {
                    //         // selectedInterest.length > 0 && selectedInterest.map((element) => {
                    //         if (data.data['registrationDetails'][0]['IsInterestedforSeminar'] && item.AreaofInterestID == 1) {
                    //             this.setState({ isInterstOne: true })
                    //             item.isSelect = true
                    //         }
                    //         if (data.data['registrationDetails'][0]['IsInterestedforb2b'] && item.AreaofInterestID == 2) {
                    //             this.setState({ isInterestTwo: true })
                    //             item.isSelect = true
                    //         }
                    //         // if (element.AreaofInterestID == item.AreaofInterestID) {
                    //         // }
                    //         // })
                    //     })
                    // }

                    // Seminar Interest List Prepare on Basis on get Days list 
                    var selectedSeminarList = data.data['seminarInterestList'] != null ? data.data['seminarInterestList'] : []
                    seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                        selectedSeminarList.length > 0 && selectedSeminarList.map((item) => {
                            if (item.SeminarID == data.SeminarID) {
                                data.isSelect = true
                            }
                        })
                    })


                    var filePath = data.data['registrationDetails'][0]['PassportFilePath'] != null ? data.data['registrationDetails'][0]['PassportFilePath'] : ''
                    var array = data.data['registrationDetails'][0]['PassportFilePath'] != null &&
                        data.data['registrationDetails'][0]['PassportFilePath'] != "" && filePath.split("/")
                    const FileName = array[array.length - 1]

                    this.setState({ passPortFileName: FileName })
                    if (
                        data.data['visitorChargeList'].length > 0
                    ) {
                        for (var i = 0; i < data.data['visitorChargeList'].length; i++) {
                            if (data.data['visitorChargeList'][i].TotalAmt != undefined) {
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'CGST') {
                                    this.setState({
                                        CGST: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'Visitor Registration Charges') {
                                    this.setState({
                                        visitorCharges: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'Total Taxable') {
                                    this.setState({
                                        totaltaxable: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.split(" ")[0].trim() == 'Seminar') {
                                    this.setState({
                                        seminarCharges: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'Grand Total') {
                                    console.log(((data.data['registrationDetails'][0].additionalChargesUSD / 100) * data.data['visitorChargeList'][i].TotalAmt).toFixed(2), 'opoppo')
                                    this.setState({
                                        totalCharges: data.data['visitorChargeList'][i].TotalAmt,
                                        toShow: data.data['visitorChargeList'][i].TotalAmt,
                                        additionalChargesUSD: ((data.data['registrationDetails'][0].additionalChargesUSD / 100) * data.data['visitorChargeList'][i].TotalAmt).toFixed(2)
                                    })
                                    sessionStorage.setItem('grandtotal', data.data['visitorChargeList'][i].TotalAmt)
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'SGST') {
                                    this.setState({
                                        SGST: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'IGST') {
                                    this.setState({
                                        IGST: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                                if (data.data['visitorChargeList'][i].Narration.trim() == 'Discount') {
                                    this.setState({
                                        promoCodeDiscount: data.data['visitorChargeList'][i].TotalAmt
                                    })
                                }
                            }
                        }
                    }


                    this.setState({

                        countryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                        attendeeTypeId: data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : '',
                        attendeeList: attendeeList,
                        daysList: daysList,
                        preName: data.data['registrationDetails'][0]['Title'] != null ? data.data['registrationDetails'][0]['Title'] : '',
                        firstName: data.data['registrationDetails'][0]['FirstName'] != null ? data.data['registrationDetails'][0]['FirstName'] : '',
                        middleName: data.data['registrationDetails'][0]['MiddleName'] != null ? data.data['registrationDetails'][0]['MiddleName'] : '',
                        lastName: data.data['registrationDetails'][0]['LastName'] != null ? data.data['registrationDetails'][0]['LastName'] : '',
                        designation: data.data['registrationDetails'][0]['Designation'] != null ? data.data['registrationDetails'][0]['Designation'] : '',
                        institute: data.data['registrationDetails'][0]['Institute_Organisation'] != null ? data.data['registrationDetails'][0]['Institute_Organisation'] : '',
                        preMobNo: Mob1Code,
                        mobNo: Mob1No,
                        preWhatsAppMobNo: Mob2Code,
                        whatsAppMobNo: Mob2No,
                        isSameAsMobNo: data.data['registrationDetails'][0]['IsSameAsMobileNo'] != null ? data.data['registrationDetails'][0]['IsSameAsMobileNo'] : '',
                        regState: data.data['registrationDetails'][0]['State'] != null ? data.data['registrationDetails'][0]['State'] : '',
                        city: data.data['registrationDetails'][0]['City'] != null ? data.data['registrationDetails'][0]['City'] : '',
                        pincode: data.data['registrationDetails'][0]['Pincode'] != null ? data.data['registrationDetails'][0]['Pincode'] : '',
                        website: data.data['registrationDetails'][0]['Website'] != null ? data.data['registrationDetails'][0]['Website'] : '',
                        email: data.data['registrationDetails'][0]['Email'] != null ? data.data['registrationDetails'][0]['Email'] : '',
                        preTelNo: telCode,
                        telNo: telNumber,
                        preTel1No: tel1Code,
                        tel1No: tel1Number,
                        industryChapterList: industryChapterList,
                        visitPurposeList: visitPurposeList,
                        primaryChapterListData: primaryChapterListData,
                        level2: level2,
                        level3: level3,
                        level4: level4,
                        needVisaAssistance: data.data['registrationDetails'][0]['isVisaAssistance'] != null ? data.data['registrationDetails'][0]['isVisaAssistance'] : '',
                        passName: data.data['registrationDetails'][0]['NameOnPassport'] != null ? data.data['registrationDetails'][0]['NameOnPassport'] : '',
                        preApplicantMobNo: appMobCode,
                        applicantMobNo: appMobileNo,
                        applicantEmail: data.data['registrationDetails'][0]['ApplicantEmailID'] != null ? data.data['registrationDetails'][0]['ApplicantEmailID'] : '',
                        passNo: data.data['registrationDetails'][0]['PassportNo'] != null ? data.data['registrationDetails'][0]['PassportNo'] : '',
                        passDate: data.data['registrationDetails'][0]['PassportIssueDate'] != null ? new Date(data.data['registrationDetails'][0]['PassportIssueDate']) : '',
                        passExipryDate: data.data['registrationDetails'][0]['PassportExpiryDate'] != null ? new Date(data.data['registrationDetails'][0]['PassportExpiryDate']) : '',
                        passCountry: data.data['registrationDetails'][0]['PassportIssuingCountryName'] != null ? data.data['registrationDetails'][0]['PassportIssuingCountryName'] : '',
                        passCountryId: data.data['registrationDetails'][0]['PassportIssuingCountryID'] != null ? data.data['registrationDetails'][0]['PassportIssuingCountryID'] : '',
                        passportFile: data.data['registrationDetails'][0]['PassportFilePath'] != null ? data.data['registrationDetails'][0]['PassportFilePath'] : '',
                        interestList: interestList,
                        remarks: data.data['registrationDetails'][0]['Remarks'] != null ? data.data['registrationDetails'][0]['Remarks'] : '',
                        isAgree: data.data['registrationDetails'][0]['ISAgree'] != null ? data.data['registrationDetails'][0]['ISAgree'] : '',
                        isVisaApplied: data.data['registrationDetails'][0]['isVisaAssistance'] != null ? data.data['registrationDetails'][0]['isVisaAssistance'] : false,
                        isPassportFilePresent: data.data['registrationDetails'][0]['PassportFilePath'] != null && data.data['registrationDetails'][0]['PassportFilePath'] != "" ? true : false,
                        isGrpDelegation: data.data['registrationDetails'][0]['IsGroupDelegation'] != null ? data.data['registrationDetails'][0]['IsGroupDelegation'] : false,
                        educationRoleTypeId: data.data['registrationDetails'][0]['EducationRoleTypeID'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeID'] : '',
                        eduRoleName: data.data['registrationDetails'][0]['EducationRoleTypeName'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeName'] : '',
                        identityCardPath: data.data['registrationDetails'][0]['IdentityCardPath'] != null && data.data['registrationDetails'][0]['IdentityCardPath'] != '' ? `${DOC_BASE_URL}${data.data['registrationDetails'][0]['IdentityCardPath']}` : '',
                        leader: data.data['registrationDetails'][0]['DelegationName'] != null ? data.data['registrationDetails'][0]['DelegationName'] : "",
                        delegationCountry: data.data['registrationDetails'][0]['DelegationCountryName'] != null ? data.data['registrationDetails'][0]['DelegationCountryName'] : "",
                        delegationCountryId: data.data['registrationDetails'][0]['DelegationCountryID'] != null ? data.data['registrationDetails'][0]['DelegationCountryID'] : "",
                        arrivalDate: data.data['registrationDetails'][0]['DelegationArrivalDate'] != null ? new Date(data.data['registrationDetails'][0]['DelegationArrivalDate']) : '',
                        departureDate: data.data['registrationDetails'][0]['DelegationDepartureDate'] != null ? new Date(data.data['registrationDetails'][0]['DelegationDepartureDate']) : '',
                        delegationRemark: data.data['registrationDetails'][0]['DelegationRemark'] != null ? data.data['registrationDetails'][0]['DelegationRemark'] : "",
                        preffDate: data.data['registrationDetails'][0]['B2BDepartureDate'] != null ? new Date(data.data['registrationDetails'][0]['B2BDepartureDate']) : '',
                        prefTime: data.data['registrationDetails'][0]['B2BPreferredTime'] != null ? data.data['registrationDetails'][0]['B2BPreferredTime'] : "",
                        b2bRemark: data.data['registrationDetails'][0]['B2BRemark'] != null ? data.data['registrationDetails'][0]['B2BRemark'] : "",
                        isParkingAvailable: data.data['registrationDetails'][0]['CarparkingAvailable'] != null ? data.data['registrationDetails'][0]['CarparkingAvailable'] : "",
                        isParkingChargable: data.data['registrationDetails'][0]['ParkingChargable'] != null ? data.data['registrationDetails'][0]['ParkingChargable'] : false,
                        parkingCharges: data.data['registrationDetails'][0]['ParkingCharges'] != null ? data.data['registrationDetails'][0]['ParkingCharges'] : 0,
                        isCarParking: data.data['registrationDetails'][0]['CarParking'] != null ? data.data['registrationDetails'][0]['CarParking'] : 0,
                        isPaid: data.data['registrationDetails'][0]['CarParking'] != null ? data.data['registrationDetails'][0]['CarParking'] : 0,
                        seminarInterestList: seminarInterestList,
                        isInvoice: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['isInvoice'] != null && data.data['registrationDetails'][0]['isInvoice'],
                        INVAddress: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVAddress_V'] != null && data.data['registrationDetails'][0]['INVAddress_V'],
                        INVCompanyName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCompanyName_V'] != null && data.data['registrationDetails'][0]['INVCompanyName_V'],
                        INVPersonName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVPersonName_V'] != null && data.data['registrationDetails'][0]['INVPersonName_V'],
                        INVTanNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVTanNo'] != null && data.data['registrationDetails'][0]['INVTanNo'],
                        GSTNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['GSTNo'] != null && data.data['registrationDetails'][0]['GSTNo'],
                        PANNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['PanNo'] != null && data.data['registrationDetails'][0]['PanNo'],
                        promoCode: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['VerifyPromoCode'] != null ? data.data['registrationDetails'][0]['VerifyPromoCode'] : '',
                        isLoading: false,
                        isPromoApply: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['VerifyPromoCode'] != null && data.data['registrationDetails'][0]['VerifyPromoCode'] != '' ? true : false,
                        // visitorCharges: pay
                        discountpercent: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['DiscountPercent'] != null && data.data['registrationDetails'][0]['DiscountPercent'] != '' ? data.data['registrationDetails'][0]['DiscountPercent'] : '',
                        regStateINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVState_V'] != null && data.data['registrationDetails'][0]['INVState_V'],
                        pincodeINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVPinCode_V'] != null && data.data['registrationDetails'][0]['INVPinCode_V'],
                        cityINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCity_V'] != null && data.data['registrationDetails'][0]['INVCity_V'],
                        countryIdINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCountryID_V'] != null && data.data['registrationDetails'][0]['INVCountryID_V'],
                    })
                    // var paymentArr = []
                    // var paymentKeys = []
                    // paymentKeys = data.data['paymentlist'].length > 0 ? Object.keys(data.data['paymentlist'][0]) : []
                    // console.log(paymentKeys, 'paymentKeyspaymentKeys')
                    // if (paymentKeys.length > 0 && paymentKeys.includes('NAME OF THE BENEFICIARY')) {
                    //     var obj = { 'Description': 'NAME OF THE BENEFICIARY', 'Details': data.data['paymentlist'][0]['NAME OF THE BENEFICIARY'] }
                    //     paymentArr.push(obj)
                    // }
                    // if (paymentKeys.length > 0 && paymentKeys.includes('CURRENT ACCOUNT NO.')) {
                    //     var obj = { 'Description': 'CURRENT ACCOUNT NO.', 'Details': data.data['paymentlist'][0]['CURRENT ACCOUNT NO.'] }
                    //     paymentArr.push(obj)
                    // }
                    // if (paymentKeys.length > 0 && paymentKeys.includes('BANK AND BRANCH')) {
                    //     var obj = { 'Description': 'BANK AND BRANCH', 'Details': `${data.data['paymentlist'][0]['BANK AND BRANCH']}` }
                    //     paymentArr.push(obj)
                    // }
                    // if (paymentKeys.length > 0 && paymentKeys.includes('SWIFT CODE')) {
                    //     var obj = { 'Description': 'SWIFT CODE', 'Details': data.data['paymentlist'][0]['SWIFT CODE'] }
                    //     paymentArr.push(obj)
                    // }
                    // if (paymentKeys.length > 0 && paymentKeys.includes('IFS Code')) {
                    //     var obj = { 'Description': 'IFS Code', 'Details': data.data['paymentlist'][0]['IFS Code'] }
                    //     paymentArr.push(obj)
                    // }
                    // if (paymentKeys.length > 0 && paymentKeys.includes('Note')) {
                    //     sessionStorage.setItem("paymentNote", data.data['paymentlist'][0].Note)
                    // }
                    // setTimeout(() => {
                    //     sessionStorage.setItem('paymentList', JSON.stringify(paymentArr))
                    // }, 100);

                    data.data['registrationDetails'].length > 1 &&
                        data.data['registrationDetails'].map(item3 => {
                            if (item3.isCoordinator) {
                                this.setState({
                                    isInvoice: item3['isInvoice'] != null && item3['isInvoice'],
                                    INVAddress: item3['INVAddress_V'] != null && item3['INVAddress_V'],
                                    INVCompanyName: item3['INVCompanyName_V'] != null && item3['INVCompanyName_V'],
                                    INVPersonName: item3['INVPersonName_V'] != null && item3['INVPersonName_V'],
                                    INVTanNo: item3['INVTanNo'] != null && item3['INVTanNo'],
                                    GSTNo: item3['GSTNo'] != null && item3['GSTNo'],
                                    PANNo: item3['PanNo'] != null && item3['PanNo'],
                                    promoCode: item3['VerifyPromoCode'] != null && item3['VerifyPromoCode'] != '' ? item3['VerifyPromoCode'] : '',
                                    isPromoApply: item3['VerifyPromoCode'] != null && item3['VerifyPromoCode'] != '' ? true : false
                                })
                            }

                        })
                    this.setState({
                        conversionRate: data.data['registrationDetails'][0].ConversionRate,
                        additionalChargesUSDper: data.data['registrationDetails'][0].additionalChargesUSD,

                    })
                    setTimeout(() => {
                        console.log(interestList)
                    }, 1000);
                } else {
                }
                this.setState({ isLoading: false })
            })
            .catch((err) => {
                console.log(err)
            })
        // }, );

    }

    // Delete Exhibitor BAdge Document Delete
    handleDelete(e) {
        e.preventDefault()
        const { isOpen } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaDoc_action()
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isOpen: !isOpen, passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    otherDetailsChange(e) {
        const { visitPurposeList } = this.state
        var value = e.target.value

        visitPurposeList.length > 0 && visitPurposeList.map((data) => {
            if (data.PurposeofVisitID == 10 && data.isSelect) {
                data.otherDetail = value
            } else {
                data.otherDetail = ""
            }
        })
        this.setState({ visitPurposeList: visitPurposeList })
        console.log("sssssssssssssssssssssss", visitPurposeList)
    }

    // On Delegation Country Search
    onDelegationCountrySearch(e) {
        const { delgationCountryList, tempDelegationCountryList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempDelegationCountryList ++++----------->", tempDelegationCountryList)

            var searchCoutryList = tempDelegationCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                delegationCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                delegationCountryErr: '',
                tempDelegationCountryList: searchCoutryList,
                isDisplayDelegationCountryList: true
            })
        }
        else {

            this.setState({
                delegationCountry: e.target.value,
                tempDelegationCountryList: delgationCountryList,
                isDisplayDelegationCountryList: false
            })
        }
    }

    // Render Country for Delegation Country
    renderDelegationCountryList() {
        const { tempDelegationCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempDelegationCountryList.length > 0 && tempDelegationCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                delegationCountry: data.Description, delegationCountryId: data.Code,
                                isDisplayDelegationCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On Check Preferred Time
    handlePrefTime(e) {
        const prefTiming = e.target.value;
        if (prefTiming >= '09:00' && prefTiming <= '17:00') {
            this.setState({ prefTime: prefTiming });
        } else {
            toastError('Preferred time must be between 9:00 and 17:00')
        }
    }

    // On Checked seminar
    onCheckedSeminar(e, id) {
        const { seminarInterestList } = this.state
        const checked = e.target.checked
        seminarInterestList.length > 0 && seminarInterestList.map((data) => {
            if (data.SeminarID == id) {
                if (checked) {
                    data.isSelect = true
                } else {
                    data.isSelect = false
                }
            }
        })
        console.log("aaaaaaaaaaa", seminarInterestList)
        this.setState({})
    }

    onFileClick() {
        this.toggleModal();
        // const url = "images/B2BEXHIBITOR.pdf"
        // window.open(url, "_blank");
    }

    toggleModal() {
        const { isOpen2 } = this.state
        this.setState({ isOpen2: !isOpen2 })
    }

    onCheckLevel1(e, id) {
        const { level2, primaryChapterListLevel2, primaryChapterListLevel3, primaryChapterListLevel4, primaryChapterListData, level3, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < primaryChapterListData.length; i++) {
            if (primaryChapterListData[i]['ChapterID'] == id) {
                if (event == true) {
                    primaryChapterListData[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level2.forEach((level2) => {
                        if (level2.ParentChapterID == id) {
                            level2.IsSelect = true

                            level3.forEach((level3) => {
                                if (level2.ChapterID == level3.ParentChapterID) {
                                    level3.IsSelect = true

                                    level4.forEach((level4) => {
                                        if (level3.ChapterID == level4.ParentChapterID) {
                                            level4.IsSelect = true

                                        }
                                    });
                                }
                            });
                        }
                    });

                } else {
                    primaryChapterListData[i]['IsSelect'] = false

                    level2.forEach((level2) => {
                        if (level2.ParentChapterID == id) {
                            level2.IsSelect = false

                            level3.forEach((level3) => {
                                if (level2.ChapterID == level3.ParentChapterID) {
                                    level3.IsSelect = false

                                    level4.forEach((level4) => {
                                        if (level3.ChapterID == level4.ParentChapterID) {
                                            level4.IsSelect = false

                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        }
        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);

    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, primaryChapterListLevel3, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2[i]['IsSelect'] = false

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        console.log("tempLevel1", tempLevel1)

        for (let i = 0; i < primaryChapterListData.length; i++) {
            for (let j = 0; j < level2.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.IsSelect == 1)
                        console.log("allSelectedChecked", allSelectedChecked)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['IsSelect'] = true
                        } else {
                            primaryChapterListData[i]['IsSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);


    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level3, primaryChapterListLevel4, level2, level4, primaryChapterListData } = this.state
        this.setState({ level4DummyId: id })
        const event = e.target.checked

        var modelevel2 = []
        var modelevel3 = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                console.log("***********", level3[i])
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })

        console.log("finalListlevel2", finalListlevel2)


        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {

                            level4.IsSelect = true
                        }
                    });

                } else {
                    level3[i]['IsSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.IsSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.IsSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['IsSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                    console.log("allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['IsSelect'] = true
                                    } else {
                                        primaryChapterListData[j]['IsSelect'] = false
                                    }
                                }
                                else {
                                    level2[index]['IsSelect'] = false
                                    primaryChapterListData[j]['IsSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);

    }

    record(level2data) {
        const { primaryChapterListLevel2, level2, level3, level4 } = this.state
        var tempLevel1 = [];
        for (var j = 0; j < level2.length; j++) {
            if (level2data.ChapterID == level2[j]['ParentChapterID']) {
                tempLevel1.push(level2[j]);
                primaryChapterListLevel2.push(level2[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2data.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel1.length > 0 && tempLevel1.map((level2data, i) => (
                            <>
                                {
                                    // level2data.ParentChapterID == primaryChapterRadio &&
                                    <div class="accordion-body">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header check-out" id={'heading_l1_' + level2data.ChapterID}>

                                                <button class={"accordion-button collapsed  tit-name"}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={'#collapse_l1_' + level2data.ChapterID} aria-expanded="false"
                                                    aria-controls={'collapse_l1_' + level2data.ChapterID}>
                                                    {level2data.IsCheckbox &&
                                                        <input type="checkbox" className="from-left-sp check-out-in" name="" key={level2data.ChapterID}
                                                            checked={level2data.IsSelect}
                                                            onClick={e => this.onCheckLevel2(e, level2data.ChapterID, tempLevel1)}
                                                        />
                                                    }
                                                    {level2data.ChapterName}
                                                </button>
                                            </h2>
                                            {this.recordTwo(level2data, level3, level4)}
                                        </div>
                                    </div>
                                }

                            </>
                        ))
                    }
                </div>
            </>
        );
    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3 } = this.state
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"

                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordThree(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4 } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                        onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                }
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level4, exhibitDetailsList, level3, level2, level4DummyId, primaryChapterListLevel3, primaryChapterListLevel4, primaryChapterListData } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })




        console.log("************** finalListlevel2", finalListlevel2)
        // console.log("************** finalListlevel3", finalListlevel3)


        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    for (let k = 0; k < level2.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.IsSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['IsSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.IsSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['IsSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                                console.log("************** allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['IsSelect'] = true

                                                } else {
                                                    primaryChapterListData[j]['IsSelect'] = false
                                                }

                                            } else {
                                                level2[k]['IsSelect'] = false
                                            }


                                        }
                                        else {
                                            level3[index]['IsSelect'] = false
                                            level2[k]['IsSelect'] = false
                                            primaryChapterListData[j]['IsSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level4: level4, level3: level3, level2: level2 })
        }, 100);


    }


    onApplyPromo() {
        // var Discount = 0
        // var validPromo = false
        // if (this.state.promoCode != '' && this.state.promoCode != null) {
        //     for (var i = 0; i < this.state.daysList.length; i++) {
        //         if (this.state.daysList[i].isSelect) {
        //             if (this.state.promoCode == this.state.daysList[i].PromoCode) {
        //                 Discount = (this.state.visitorCharges * this.state.daysList[i].PromoCodeDiscount) / 100
        //                 validPromo = true
        //                 this.setState({ isPromoApply: true, promoCodeDiscount: Discount })
        //                 break
        //             }
        //         }
        //     }
        //     if (!validPromo) {
        //         toastError("Invalid Promo Code")
        //     }
        // } else {
        //     toastError("Please enter Promo Code")
        // }
        const { attendeeList, daysList, industryChapterList, GroupDetailsList, visitorGroupList, educationRoleTypeId, visitPurposeList, interestList, seminarInterestList, primaryChapterListData,
            level2, level3, level4, promoCode } = this.state
        // this.setState({ isLoading: true })
        var id = ''
        for (var i = 0; i < GroupDetailsList.length; i++) {
            if (GroupDetailsList[i].isCoordinator) {
                id = GroupDetailsList[i].ExhVisitorID
                break
            }
        }
        if (promoCode != '' && promoCode != null) {
            this.setState({
                isLoading: true,
                // visitorCharges: '',
                // CGST: '',
                // SGST: '',
                // IGST: '',
                promoCodeDiscount: '',
                // totalCharges: '',
            })
            this.props.verifyVisitorPromoCode_action(id, promoCode)
                .then((data) => {
                    console.log(data)
                    if (data.error != 1) {
                        // sessionStorage.setItem('promoCode', promoCode)

                        this.setState({
                            isPromoApply: true, visitorGroupList: [],
                            GroupDetailsList: []
                        }, () => this.getVisitorRegistrationDetails())
                    } else {
                        toastError(data.msg)
                        this.setState({ isLoading: false })
                    }
                    // this.setState({ isLoading: false })
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError('Please enter PromoCode')
        }
    }

    onCancelPromo() {
        const { attendeeList, daysList, industryChapterList, GroupDetailsList, visitorGroupList, educationRoleTypeId, visitPurposeList, interestList, seminarInterestList, primaryChapterListData,
            level2, level3, level4, promoCode } = this.state
        // this.setState({ isLoading: true })
        var id = ''
        for (var i = 0; i < GroupDetailsList.length; i++) {
            if (GroupDetailsList[i].isCoordinator) {
                id = GroupDetailsList[i].ExhVisitorID
                break
            }
        }
        // if (promoCode != '' && promoCode != null) {
        this.setState({
            isLoading: true,
            // visitorCharges: '',
            // CGST: '',
            // SGST: '',
            // IGST: '',
            promoCodeDiscount: '',
            // totalCharges: '',
        })
        this.props.verifyVisitorPromoCode_action(id, '')
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    // sessionStorage.setItem('promoCode', '')
                    this.setState({
                        isPromoApply: false, promoCode: '', visitorGroupList: [],
                        GroupDetailsList: []
                    }, () => this.getVisitorRegistrationDetails())
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
                // this.setState({ isLoading: false })
            })
            .catch((err) => {
                console.log(err)
            })
        // } else {
        //     toastError('Please enter PromoCode')
        // }
        // this.setState({ isPromoApply: false, promoCodeDiscount: 0, promoCode: '' })
    }

    // On Previous Click
    onPrevClick(e) {
        e.preventDefault()
        if (this.state.isPromoApply) {
            this.setState({
                promocodeModel: true
            })
        }
        else {
            this.props.navigate('/visitorindustrysegment', { state: { is_previous: true } })
        }
    }

    renderGroupList(list) {
        const { GroupDetailsList, isVisaApplied, daysList, attendeeTypeId, interestList, seminarInterestList, isInvoice, INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr } = this.state
        // var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
        // daysList.length > 0 && daysList.map((item) => {
        //     selectedDaysList.length > 0 && selectedDaysList.map((element) => {
        //         if (element.VisitDate == item.VisitDate) {
        //             item.isSelect = true
        //         }
        //     })
        // })
        console.log(list, 'ppplist', seminarInterestList)
        return (<>
            <ul class="list-group " style={{ position: 'relative' }}>
                {
                    list.length > 0 && list.map((data, i) => (
                        <>
                            <li class="list-group-item" key={Math.random()}>
                                <div className="added-more p-3 rounded-3">
                                    <h5 style={{ color: "#0056ff" }}>{data.isCoordinator ? 'Coordinator' : `Visitor ${i}`}</h5>
                                    <div className="row mt-4">
                                        <div className="col-md-4">
                                            <h6>First Name: {data.firstName}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Middel Name: {data.middleName}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Last Name: {data.lastName}</h6>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-4">
                                            <h6>Country: {data.CountryName}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Email: {data.email}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Institue/Organisation: {data.institute}</h6>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-4">
                                            <h6>Mobile: {data.mobNo}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>WhatsApp No:  {data.whatsAppMobNo}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Pincode: {data.pincode}</h6>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-4">
                                            <h6>State: {data.regState}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>City: {data.city}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>website: {data.website}</h6>
                                        </div>

                                    </div>
                                    <div className="row mt-2">
                                        {/* {attendeeTypeId == 3 && <div className="col-md-4"> */}
                                            <h6>Education Role: {data.eduRoleName}</h6>
                                        {/* </div>} */}
                                        {/* {attendeeTypeId == 3 && data.identityCardPath != null && data.identityCardPath != '' && <div className="col-md-4"> */}
                                            <h6>Identity Card</h6>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm rounded-0"
                                                onClick={() => window.open(data.identityCardPath, '_blank')}
                                            >
                                                View
                                            </button>
                                        {/* </div>} */}
                                        <div className="col-md-4">
                                            <h6>Designation: {data.designation}</h6>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>TelePhone: {data.Telephone}</h6>
                                        </div>
                                        <div className={attendeeTypeId == 3 ? "col-md-4 mt-2" : 'col-md-4'}>
                                            <h6>TelePhone 1: {data.telNo1}</h6>
                                        </div>
                                        {/* <button
                                        type="button"
                                        className="btn btn-danger rounded-0"
                                        style={{ marginRight: '10px', width: '100px' }}
                                        onClick={() => this.handleDeleteAddedVisitor(index - 1)}
                                    >
                                        delete
                                    </button> */}
                                    </div>
                                </div>

                                {data.DateList.length > 0 && <div className="containerfluid">
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg d-flex">
                                                <p className="mb-0">
                                                    Date of Visit Single Day Pass / All Day Pass{" "}
                                                    <span className="text-red">*</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-xl-4 mb-4">
                                    <div className="row mt-4" >
                                        {
                                            data.DateList.length > 0 && data.DateList.map((element, index) => (
                                                <>
                                                    {/* {data.isSelect && */}
                                                    <div className="col-sm-4" key={element.Code}>
                                                        <label className="d-flex">
                                                            <input type="checkbox" select={element.isSelect}
                                                                checked={element.isSelect} value={element.Code} disabled={true}
                                                            // onChange={(e) => this.onSelectDates(e)}
                                                            />
                                                            {element.VisitDate}
                                                        </label>
                                                    </div>
                                                    {/* } */}
                                                </>
                                            ))
                                        }
                                    </div>
                                </div>
                                {
                                    data.isGrpDelegation &&
                                    <div className="one-section mb-3">
                                        {
                                            data.isGrpDelegation &&
                                            < div
                                                className="list-group-item col-md-12 m-3"
                                                id="divMsg"
                                            // style={{backgroundColor:}}
                                            >
                                                <h5>Group Delegation</h5>

                                                <div className="row">
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Delegation Leader/Organisation<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={data.leader} maxLength={'50'}
                                                            disabled
                                                            onChange={(e) => this.setState({ leader: e.target.value, leaderErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{leaderErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Country/Region<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={data.delegationCountry} disabled
                                                            onChange={(e) => this.onDelegationCountrySearch(e)}
                                                        />
                                                        {/* {isDisplayDelegationCountryList && this.renderDelegationCountryList()} */}
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{delegationCountryErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Arrival Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.arrivalDate}
                                                            onChange={(date) =>
                                                                this.setState({
                                                                    arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                    arrivalDateErr: ""
                                                                })}
                                                            disabled
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="Arrival Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Departure Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.departureDate}
                                                            onChange={(date) =>
                                                                this.setState({
                                                                    departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                    departureDateErr: ""
                                                                })}
                                                            disabled
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="Departure Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>} */}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xl-12 mb-1">
                                                            <label className="mt-3">Remark
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={3}
                                                                maxLength={'250'}
                                                                defaultValue={""}
                                                                disabled
                                                                value={data.delegationRemark}
                                                                onChange={(e) => this.setState({ delegationRemark: e.target.value, delegationRemarkErr: "" })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{delegationRemarkErr}</span>} */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {data.isShowIntrestList &&
                                    <div >
                                        <div className="containerfluid">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Interested</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 mb-4">
                                            {console.log(interestList, 'interestList', data.isInterestTwo, data.isInterstOne)}
                                            <div className="row mt-4">
                                                {
                                                    interestList.length > 0 && interestList.map((item) => (
                                                        <>
                                                            {data.isShowIntrestList &&
                                                                <>
                                                                    <div className="col-sm-12 mb-2" key={item.AreaofInterestID}>
                                                                        <label className="d-flex">
                                                                            <input type="checkbox" name="fav_language" value={item.AreaofInterestID}
                                                                                select={item.AreaofInterestID == 2 ? data.isInterestTwo : item.AreaofInterestID == 1 ? data.isInterstOne : false} checked={item.AreaofInterestID == 2 ? data.isInterestTwo : item.AreaofInterestID == 1 ? data.isInterstOne : false}
                                                                                // onChange={(e) => this.onSelectInterest(e)}
                                                                                disabled
                                                                            />
                                                                            {item.Name}

                                                                        </label>
                                                                        {data.isInterestTwo && item.AreaofInterestID == 2 &&
                                                                            < div >
                                                                                <div className="col-sm-3 ">
                                                                                    <label className="d-flex">
                                                                                        <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>If interested Please fill preferred Date & Time</strong>
                                                                                            (Exhibition time is 09:30hrs to 18:00hrs) <a className="text-primary"
                                                                                                onClick={(e) => this.onFileClick(e)}><spa className="text-danger blink-soft">Click here</spa> to view exhibitor list for meeting at respective booth.</a></span>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-12 mb-2"
                                                                                    id="divMsg"
                                                                                >
                                                                                    <div className="row">
                                                                                        <div className="col-xl-3">
                                                                                            <label className="mt-1">Date
                                                                                                <span className="text-red">*</span>
                                                                                            </label>
                                                                                            <DatePicker selected={data.B2BDepartureDate}
                                                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                                peekNextMonth
                                                                                                value={data.B2BDepartureDate}
                                                                                                showMonthDropdown
                                                                                                showYearDropdown
                                                                                                disabled
                                                                                                dropdownMode="select"
                                                                                                placeholderText="Preferred Date"
                                                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                                                popperClassName="example-datepicker-class" />
                                                                                            <div>
                                                                                                <div >
                                                                                                    <label>preferred Time<span className="text-red">*</span></label>
                                                                                                    <input
                                                                                                        type="time"
                                                                                                        disabled
                                                                                                        className="form-control"
                                                                                                        value={data.B2BPreferredTime}
                                                                                                    />
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>


                                                                                    </div>

                                                                                    <div className="row">
                                                                                        <div className="col-xl-8 mb-1">
                                                                                            <label className="mt-1">Remark
                                                                                            </label>
                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows={3}
                                                                                                maxLength={'250'}
                                                                                                disabled
                                                                                                defaultValue={""}
                                                                                                value={data.B2BRemark}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {data.isInterstOne && item.AreaofInterestID == 1 &&
                                                                            <div className="table-responsive" >
                                                                                <table className="table border table-bordered mb-0 mt-1" >
                                                                                    <thead>
                                                                                        <tr>
                                                                                            {/* <th className="text-center">Day</th> */}
                                                                                            <th style={{ width: '180px' }}>Date & Time</th>
                                                                                            <th style={{ width: '680px' }}>Session Name</th>
                                                                                            {/* <th style={{ width: '380px' }}>Speaker</th> */}
                                                                                            <th style={{ width: '120px' }} className="text-center"></th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            data.seminarList.length > 0 && data.seminarList.map((item3) => (
                                                                                                seminarInterestList.length > 0 && seminarInterestList.map((item2) => (
                                                                                                    item2.SeminarID == item3.SeminarID &&
                                                                                                    <tr key={Math.random()}>
                                                                                                        {/* <td className={data.ParentSeminarID != 0 ? "text-center" : "fw-bold"}>{data.Day}</td> */}
                                                                                                        <td className={item2.ParentSeminarID != 0 ? null : "fw-bold"}>{item2.DateTime}</td>
                                                                                                        <td className={item2.ParentSeminarID != 0 ? null : "fw-bold"}>{item2.SessionName}</td>
                                                                                                        {/* {data.SeminarID != 14 ? (
                                                                                                    <td>{data.Speaker}</td>
                                                                                                ) : (
                                                                                                    <td>{data.Speaker.split('==').map(item => (
                                                                                                        <tr className="text-start">{item}</tr>
                                                                                                    ))}</td>
                                                                                                )} */}
                                                                                                        <td className="text-center">
                                                                                                            {item2.ParentSeminarID != 0 &&
                                                                                                                item2.SeminarTypeID == 1 ? <input type="checkbox"
                                                                                                                    value={item2.isSelect}
                                                                                                                    checked={item2.isSelect}
                                                                                                                    disabled
                                                                                                                    onChange={(e) => this.onCheckedSeminar(e, item2.SeminarID)}
                                                                                                            /> : item2.SeminarTypeID == 2 ? <span>
                                                                                                                <strong>Request for Invite</strong>
                                                                                                            </span> :
                                                                                                                <span>
                                                                                                                    Seminar Charges: <strong>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{sessionStorage.getItem("countryId") == 91 ? item2.PriceINR : item2.PriceUSD}</strong>
                                                                                                                </span>
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                ))
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>

                                                                                <div />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </>
                                                            }</>
                                                    ))
                                                }
                                            </div >
                                        </div>
                                    </div>}

                                {data.isVisaAssistance &&
                                    <div className="one-section mb-3">
                                        {/* <div className="containerfluid">
                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="p-1 title-bg d-flex">
                                                    <p className="mb-0">
                                                        Visa Application<span className="text-red">*</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {
                                            data.isVisaAssistance && sessionStorage.getItem('VisitorTypeID') == 2 &&
                                            //map+all data points
                                            data.isVisit && < div
                                                className="list-group-item col-md-12 m-3"
                                                id="divMsg"
                                            // style={{backgroundColor:}}
                                            >
                                                <h5>Visa Application</h5>
                                                <div className="row">
                                                    {/* <h5>{data.isCoordinator ? 'Coordinator' : `Visitor ${i}`}</h5> */}
                                                    {console.log('ppp')}
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Name as per Passport<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" disabled className="form-control" value={data.passName} maxLength={'50'}
                                                            onChange={(e) => this.onInput(e, e.target.value, i, 'name')}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passNameErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Applicant mobile number<span className="text-red">*</span>
                                                        </label>
                                                        <input type="number" disabled className="form-control" value={data.applicantMobNo}
                                                            style={{ paddingLeft: "50px" }}
                                                            maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                            onPaste={(e) => this.handlePaste(e)}
                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control-1 mt-2"
                                                            // placeholder="ISD"
                                                            value={data.preApplicantMobNo}
                                                            disabled
                                                            // onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                            maxLength={'10'}
                                                            style={{
                                                                width: 45,
                                                                position: "absolute",
                                                                top: 30,
                                                                padding: " 6px !important",
                                                                paddingLeft: 5,
                                                                borderLeft: 0,
                                                                borderTop: 0,
                                                                background: "none",
                                                                borderBottom: 0,
                                                                height: 34
                                                            }}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantMobNoErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Applicant email id<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={data.applicantEmail} maxLength={'50'}
                                                            disabled
                                                        // onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantEmailErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport No
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" disabled className="form-control" value={data.passNo} maxLength={'10'}
                                                            // onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                            onChange={(e) => this.onInput(e, e.target.value, i, 'passno')}

                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passNoErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport issue Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.passDate} disabled
                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDate')}
                                                            // onChange={(date) =>
                                                            //     this.setState({
                                                            //         passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            //         passDateErr: ""
                                                            //     })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            maxDate={data.passExipryDate}
                                                            dropdownMode="select"
                                                            placeholderText="Passport Issued Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passDateErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport Expiry Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.passExipryDate} disabled
                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDateEx')}
                                                            // onChange={(date) =>
                                                            //     this.setState({
                                                            //         passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            //         passExipryDateErr: ""
                                                            //     })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            minDate={data.passDate}
                                                            dropdownMode="select"
                                                            placeholderText="Passport Expiry Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passExipryDateErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Passport issuing Country<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={data.passCountry} disabled
                                                            onChange={(e) => this.onInput(e, e, i, 'passCountry')}

                                                        />
                                                        {data.isDisplayPassCountryList && this.renderPassCountryList(i)}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passCountryErr}</span>}
                                                    </div>
                                                    {!(data.isPassportFilePresent) &&
                                                        <div className="col-xl-5">
                                                            <label className="mt-3">
                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                <input
                                                                    // type="file" id="passportFile" name="filename"
                                                                    //     accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                    //     onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                    type="file"
                                                                    id={`path${i}`}
                                                                    disabled
                                                                    className="image-upload"
                                                                    accept=".jpg, .jpeg, .png"
                                                                    onChange={e => this.onInput(e, e.target.files, i, 'passImg')}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{data.passportFileErr}</span>}
                                                                {/* {
                                        data.passportFile != "" &&
                                        <i class="fa fa-times text-danger img-can"
                                            onClick={() => this.onCrossClick(1, i)}
                                        ></i>
                                    } */}
                                                            </form>
                                                        </div>
                                                    }
                                                    {
                                                        isVisaApplied && data.passportFilePath != "" && data.passportFilePath != null && data.isPassportFilePresent &&
                                                        <div className="col-xl-5">
                                                            <label className="mt-3">
                                                                Passport Front Page File
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <div style={{
                                                                border: '1px solid #ccc',
                                                                padding: '10px',

                                                                // display: 'inline-flex',
                                                                alignItems: 'center',
                                                                marginTop: '10px',
                                                                // marginLeft: '12px',
                                                                maxWidth: '300px'
                                                            }}>
                                                                <span style={{ marginRight: '10px' }}
                                                                >{data.passportFile}</span>
                                                                {/* <i className="fa fa-times text-danger img-can"
                                        onClick={() => this.onCrossClick(1, i)}
                                    ></i> */}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        }
                                    </div>}
                                {data.isCoordinator && <div className="one-section">
                                    <div className="containerfluid">
                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="p-1 title-bg ">
                                                    <label className="ms-2 fw-semibold">
                                                        <input type="checkbox" name="fav_language"
                                                            disabled
                                                            value={this.state.isInvoice} checked={this.state.isInvoice}
                                                            onClick={(e) => this.setState({
                                                                isInvoice: !this.state.isInvoice,
                                                                INVPersonNameErr: '',
                                                                INVCompanyNameErr: '',
                                                                INVAddressErr: '',
                                                                INVTanNoErr: '',
                                                                GSTNoErr: '',
                                                                PANNoErr: '',
                                                            })}
                                                        />Invoice Details
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.isInvoice && <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">Person Incharge Name<span className="text-red">*</span></label>
                                                <input type="text" className="form-control" value={INVPersonName}
                                                    disabled
                                                    maxLength={'50'}
                                                    onChange={(e) => this.setState({ INVPersonName: e.target.value, INVPersonNameErr: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{INVPersonNameErr}</span>}
                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">Company Name<span className="text-red">*</span></label>
                                                <input type="text" className="form-control" value={INVCompanyName}
                                                    disabled
                                                    maxLength={'200'}
                                                    onChange={(e) => this.setState({ INVCompanyName: e.target.value, INVCompanyNameErr: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{INVCompanyNameErr}</span>}

                                            </div>
                                            <div className="col-xl-6 mb-1">
                                                <label className="mt-3">Address
                                                    <span className="text-red">*</span>
                                                </label>
                                                <input type="text" className="form-control" value={INVAddress} maxLength={'50'}
                                                    disabled
                                                    onChange={(e) => this.setState({ INVAddress: e.target.value, INVAddressErr: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{INVAddressErr}</span>}
                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">PAN Number<span className="text-red">*</span></label>
                                                <input type="text" className="form-control" value={PANNo}
                                                    disabled
                                                    maxLength={'50'}
                                                    onChange={(e) => {
                                                        // const errMsg = panNoValidator(e.target.value)
                                                        this.setState({ PANNo: e.target.value, PANNoErr: '' })
                                                        // if (errMsg != '') {
                                                        //     this.setState({
                                                        //         PANNoErr: errMsg,
                                                        //     })
                                                        // } else {
                                                        //     this.setState({
                                                        //         PANNoErr: "",
                                                        //     })
                                                        // }
                                                    }
                                                    }
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{PANNoErr}</span>}
                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">TAN Number<span className="text-red">*</span></label>
                                                <input type="text" className="form-control" value={INVTanNo}
                                                    disabled
                                                    maxLength={'50'}
                                                    onChange={(e) => {
                                                        // const errMsg = tanNoValidator(e.target.value)
                                                        this.setState({
                                                            INVTanNo: e.target.value,
                                                        })
                                                        // if (errMsg != '') {
                                                        //     this.setState({
                                                        //         INVTanNoErr: errMsg,
                                                        //     })
                                                        // } else {
                                                        //     this.setState({
                                                        //         INVTanNoErr: "",
                                                        //     })
                                                        // }
                                                    }}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{INVTanNoErr}</span>}
                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">GST Number<span className="text-red">*</span></label>
                                                <input type="text" className="form-control" value={GSTNo}
                                                    disabled
                                                    maxLength={'50'}
                                                    onChange={(e) =>
                                                        this.onGSTchange(e.target.value)
                                                    }
                                                // onInput={toInputUppercase}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{GSTNoErr}</span>}
                                            </div>
                                        </div>
                                    </div>}
                                </div>}
                                {data.chapterArr.length > 0 &&
                                    <div className="one-section">
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg d-flex">
                                                        <p className="mb-0 fw-semibold">
                                                            Industry Segment{" "}
                                                            <span className="text-red">*</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mb-2">
                                            <div className="row mt-1">
                                                <div className="asc">
                                                    <div className="" style={{ paddingLeft: 10 }}>
                                                        <form className="needs-validation pb-2" noValidate="">
                                                            <div className="form-row">
                                                                {
                                                                    data.chapterArr.length > 0 && data.chapterArr.map((element, index) => (
                                                                        <div className="col-sm-3 mb-3">
                                                                            <section className="accordion" key={element.IndustrySegmentID}>
                                                                                <label>
                                                                                    <input type="checkbox"
                                                                                        select={element.IsSelect} checked={element.IsSelect}
                                                                                        value={element.IndustrySegmentID} disabled
                                                                                    // onChange={(e) => this.onSelectPrimaryChapter(e)}
                                                                                    />
                                                                                    {element['Industrial Segment']}
                                                                                </label>
                                                                            </section>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {data.hallList.length > 0 &&
                                    <>
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg d-flex">
                                                        <p className="mb-0 fw-semibold">
                                                            Products List <span className="text-red">*</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="" style={{ marginLeft: "10px" }}>
                                            <p className="mb-0" style={{ fontSize: 15 }}>
                                                <strong> Selected Products List</strong>
                                            </p>
                                        </div>
                                        <div style={{ padding: "0px 0px 0px 10px" }}>
                                            {
                                                data.hallList.length > 0 ? data.hallList.map((element) => (
                                                    <p>
                                                        {element.ChapterName}
                                                    </p>
                                                )) :
                                                    <p>
                                                        {"No Results"}
                                                    </p>
                                            }
                                        </div>
                                    </>
                                }
                            </li>
                            {/* <hr className="m-1" /> */}

                        </>

                    ))
                }
            </ul>
        </>
        )
    }

    render() {
        const { isLoading, country, totalCharges, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName, isOpenConfirmationModal, pgViewChargesModal, pgViewAddChargesModal, additionalChargesUSD,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, visitorCharges,
            promoCodeDiscount, isPromoApply, promoCode, isPaymentEnable, GroupDetailsList, visitorGroupList,
            isInvoice, discountpercent, isOpen4, additionalChargesUSDper,
            countryIdINV, pincodeINV, regStateINV, cityINV,
            INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr
        } = this.state
        var toShowEduRole = false
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (data.AttendeeTypeName == "Education Sector & Others") {
                if (data.isChecked) {
                    toShowEduRole = true
                }
            }
        })
        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
        const industryChapFilter = industryChapterList.filter((item) => item.IsSelect)
        const seminarInterestFilter = seminarInterestList != null && seminarInterestList != '' && seminarInterestList != undefined ? seminarInterestList.filter((item) => item.isSelect || item.ParentSeminarID == 0) : []
        console.log('interestListinterestListinterestList', seminarInterestList, seminarInterestFilter)
        const isAnyInterest = interestList.some((obj) => obj.isSelect)
        // const totalCharges = visitorCharges + (isCarParking ? parkingCharges : 0) - promoCodeDiscount
        var finalArr = []
        for (var i = 0; i < this.state.visitorGroupList.length; i++) {
            var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
            finalArr.push(obj)
        }
        var paymentDatesList = []
        if (finalArr.length > 0) {
            var noOfVisitor = 1
            for (var i = 0; i < finalArr.length; i++) {
                var obj = { name: `${finalArr[i].firstName} ${finalArr[i].lastName}`, displayDates: [] }
                // !finalArr[i].isCoordinator && noOfVisitor++
                for (var j = 0; j < finalArr[i].DateList.length; j++) {
                    // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                    obj.displayDates.push(finalArr[i].DateList[j].VisitDate)
                }
                obj.displayDates.length > 0 && obj.displayDates.join(', ')
                paymentDatesList.push(obj)
            }
        } else {
            for (var i = 0; i < daysList.length; i++) {
                // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                if (daysList[i].isSelect) {
                    paymentDatesList.push(daysList[i].VisitDate)
                }
                // finalArr.push(obj)
            }
        }
        var seminarChargesShowList = []
        if (finalArr.length > 0) {

            var noOfVisitor = 1
            for (var i = 0; i < finalArr.length; i++) {
                var obj = { name: `${finalArr[i].firstName} ${finalArr[i].lastName}`, displaySeminar: [] }
                // !finalArr[i].isCoordinator && noOfVisitor++
                for (var j = 0; j < finalArr[i].seminarList.length; j++) {
                    // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                    seminarInterestFilter.map(item => {
                        if (finalArr[i].seminarList[j].SeminarID == item.SeminarID) {
                            if (item.SeminarTypeID == 3) {
                                obj.displaySeminar.push(item.SessionName)

                            }
                        }
                    })
                }
                obj.displaySeminar.length > 0 && obj.displaySeminar.join(', ')
                seminarChargesShowList.push(obj)
            }
        } else {
            for (var i = 0; i < seminarInterestFilter.length; i++) {
                // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                if (seminarInterestFilter[i].SeminarTypeID == 3) {
                    seminarChargesShowList.push(seminarInterestFilter[i].SessionName)
                }
                // finalArr.push(obj)
            }
        }

        // paymentDatesList.length > 0 && paymentDatesList.toString()
        console.log('-----', finalArr, daysList, paymentDatesList)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        console.log("payyyyy", seminarChargesShowList, totalCharges)
        console.log(interestList, ';;', seminarInterestFilter)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                <VisitorHeader />
                {/* <VisitorDrawer /> */}
                <Modal isOpen={isOpen2} onRequestClose={(e) => this.toggleModal(e)}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail"
                    // tabIndex={-1}
                    // aria-labelledby="detailLabel"
                    // aria-hidden="true"
                    >
                        <div className="modal-dialog modal-md">
                            <div className="modal-content estimate-details2">
                                <div className="modal-header pb-1">
                                    <h5 className="modal-title" id="detailLabel">
                                        <strong>Exhibitor list for meeting at respective booth.</strong>
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close pt-6"
                                        data-bs-dismiss="modal"
                                        style={{ fontSize: 12 }}
                                        aria-label="Close"
                                        onClick={(e) => this.toggleModal(e)}
                                    />
                                </div>
                                <iframe
                                    id="myIframe"
                                    src='images/B2BEXHIBITOR.pdf#toolbar=0'
                                    width="800px"
                                    height="800px"
                                // title="Bing"
                                />

                            </div>
                        </div>
                    </div>
                </Modal>
                <div
                    className="main-content app-content mt-0"
                    style={{ marginInlineStart: 0 }}
                >
                    <div className="side-app">
                        <div className="container-fluid p-0">
                            <div className="row m-0">
                                <div
                                    className="breadcrumb-scroll-fixed p-0"
                                >
                                    <h6 className="mb-0 p-2 text-white">Visitor Registration form Preview</h6>
                                </div>
                            </div>
                        </div>
                        {sessionStorage.getItem('VisitorTypeID') == 1 && <div className="combine-section">
                            <div className="needs-validation after-step mt-1 " style={{ marginTop: 115 }}>
                                <div id="Menu1">
                                    <div id="section-1" style={{ marginTop: '7rem' }}>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg" style={{ marginTop: "10px" }}>
                                                            <p className="mb-0 fw-semibold">Country</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <div className="d-flex">
                                                    <label className="mt-2 w-auto" >
                                                        Select Country
                                                        <span className="text-red">*</span>

                                                    </label>
                                                    {/* {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdErr}</span>} */}
                                                </div>
                                                <select className="form-control"
                                                    value={countryId} disabled={true}
                                                // onChange={(e) => this.onCountrySelect(e)}
                                                >
                                                    <option>Select Your Country</option>
                                                    {
                                                        countryList.length > 0 && countryList.map((data) => (
                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0 fw-semibold">
                                                                Visitor Type <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'></span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 mb-3">
                                                <div className="row mt-3">
                                                    {
                                                        this.state.visitorTypeList.length > 0 && this.state.visitorTypeList.map((data) => (
                                                            <div className="col-sm-4" key={data.VisitorTypeID}>
                                                                <label className="d-flex">
                                                                    <input type="radio" name="vistorType" value={data.VisitorTypeID}
                                                                        checked={data.VisitorTypeID == this.state.VisitorTypeID} disabled
                                                                        // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                                        onChange={(e) => this.setState({ VisitorTypeID: data.VisitorTypeID, GroupDetailsList: [] })}
                                                                    />
                                                                    {data.VisitorType}
                                                                </label>
                                                            </div>
                                                        ))
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0 fw-semibold">
                                                                Attendee Type <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{attendeeTypeErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-8 mb-4">
                                                <div className="row mt-4">
                                                    {
                                                        attendeeList.length > 0 && attendeeList.map((data) => (
                                                            <>
                                                                {
                                                                    data.isChecked &&
                                                                    <div className="col-sm-4" key={data.AttendeeTypeID}>
                                                                        <label className="d-flex">
                                                                            <input type="radio" name="attendeeType" value={data.AttendeeTypeID}
                                                                                checked={data.isChecked} disabled={true}
                                                                                onChange={(e) => this.onAttendeeSelect(e)}
                                                                            />
                                                                            {data.AttendeeTypeName}
                                                                        </label>
                                                                    </div>
                                                                }
                                                            </>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0 fw-semibold">
                                                                Date of Visit Single Day Pass / All Day Pass{" "}
                                                                <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 mb-4">
                                                <div className="row mt-4" >
                                                    {
                                                        daysList.length > 0 && daysList.map((data, index) => (
                                                            <>
                                                                {data.isSelect &&
                                                                    <div className="col-sm-4" key={data.Code}>
                                                                        <label className="d-flex">
                                                                            <input type="checkbox" select={data.isSelect}
                                                                                checked={data.isSelect} value={data.Code} disabled={true}
                                                                                onChange={(e) => this.onSelectDates(e)}
                                                                            />
                                                                            {data.VisitDate}
                                                                        </label>
                                                                    </div>
                                                                }
                                                            </>
                                                        ))
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                        {sessionStorage.getItem('VisitorTypeID') == 1 && <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0 fw-semibold">Personal Information</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-xl-3 mt-3">
                                                        <label>
                                                            First Name <span className="text-red">*</span>
                                                        </label>

                                                        <div className="input-group">
                                                            {/* Prefix */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={preName}
                                                                disabled
                                                                style={{ maxWidth: "70px" }}
                                                            />

                                                            {/* Other Prefix (only when selected) */}
                                                            {isOtherPreName && (
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={otherName}
                                                                    disabled
                                                                    style={{ maxWidth: "120px" }}
                                                                />
                                                            )}

                                                            {/* First Name */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={firstName}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-xl-3 mb-1">
                                                        <label className="mt-3">Middle Name</label>
                                                        <input type="text" className="form-control"
                                                            value={middleName} disabled
                                                            maxLength={'50'}
                                                        // onChange={(e) => this.setState({ middleName: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label className="mt-3">Last Name
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control"
                                                            value={lastName} maxLength={'50'} disabled
                                                        // onChange={(e) => this.setState({ lastName: e.target.value, lastNameErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label className="d-flex mt-3">
                                                            Institute/Organisation <span className="rad-star text-danger">*</span>
                                                        </label>
                                                        <input type="text" className="form-control"
                                                            value={institute} maxLength={'500'} disabled
                                                            onChange={(e) => this.setState({ institute: e.target.value, instituteErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{instituteErr}</span>}

                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-xl-4 mb-4">
                                            <div className="row mt-2">
                                                <div className="col-sm-2">
                                                    <label className="d-flex">
                                                        Gender:
                                                        <span className="text-red">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-sm-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="gender"
                                                            checked={gender == "Male"}
                                                            onChange={e => this.setState({ gender: "Male" })}
                                                        />
                                                        Male
                                                    </label>
                                                </div>
                                                <div className="col-sm-4">
                                                    <label className="d-flex">
                                                        <input type="radio" name="gender"
                                                            checked={gender == "Female"}
                                                            onChange={e => this.setState({ gender: "Female" })}
                                                        />
                                                        Female
                                                    </label>
                                                </div>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{genderErr}</span>}
                                            </div>
                                        </div> */}
                                            <div className="col-xl-12 mb-4">

                                                <div className="row">

                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2"> Email
                                                            <span className="rad-star text-danger">*</span>
                                                        </label>
                                                        <input type="text" className="form-control"
                                                            value={email} maxLength={'50'} disabled
                                                        // onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>} */}
                                                    </div>
                                                    <div className="col-sm-3 mt-2">
                                                        <label className="d-flex">
                                                            Mobile No <span className="rad-star text-danger">*</span>
                                                        </label>

                                                        <div className="input-group">
                                                            {/* ISD */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={preMobNo}
                                                                disabled
                                                                style={{ maxWidth: "70px" }}
                                                            />

                                                            {/* Mobile Number */}
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                value={mobNo}
                                                                disabled
                                                            />
                                                        </div>

                                                        {mobNoErr && (
                                                            <span className="text-danger d-block mt-1">{mobNoErr}</span>
                                                        )}
                                                    </div>

                                                    <div className="col-sm-3 mt-2">
                                                        <label className="d-flex">
                                                            WhatsApp Mobile No <span className="rad-star text-danger">*</span>
                                                        </label>

                                                        <div className="input-group">
                                                            {/* ISD */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={preWhatsAppMobNo}
                                                                disabled
                                                                style={{ maxWidth: "70px" }}
                                                            />

                                                            {/* WhatsApp Number */}
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                value={whatsAppMobNo}
                                                                disabled
                                                            />
                                                        </div>

                                                        {whatsAppMobNoErr && (
                                                            <span className="text-danger d-block mt-1">
                                                                {whatsAppMobNoErr}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-6">
                                                            <input type="checkbox" name="fav_language"
                                                                value={isSameAsMobNo} checked={isSameAsMobNo} disabled
                                                                onClick={(e) => this.onSameAsMobNoClick(e)}
                                                            />
                                                            Same as Mobile No
                                                        </label>
                                                    </div>
                                                    {toShowEduRole && <div className="col-xl-3">
                                                        <div className="d-flex">
                                                            <label className="w-auto mt-2" >
                                                                Education Role
                                                                <span className="text-red">*</span>

                                                            </label>

                                                        </div>
                                                        <select className="form-control" value={this.state.educationRoleTypeId}
                                                            onChange={(e) => this.onEduRoleSelect(e)}
                                                            disabled
                                                        >
                                                            <option value={''}>Select Education Role</option>
                                                            {
                                                                this.state.educationRoleTypeList.length > 0 && this.state.educationRoleTypeList.map((data) => (
                                                                    <option key={data.EducationRoleTypeID} value={data.EducationRoleTypeID} >{data.EducationRoleTypeName}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.educationRoleTypeIdErr}</span>}
                                                    </div>}
                                                    {toShowEduRole && this.state.identityCardPath != null && this.state.identityCardPath != '' && <div className="col-xl-3">
                                                        <label className="mt-2">Identity Card</label>
                                                        <div className="text-left">
                                                            <i
                                                                className="fa fa-eye"
                                                                style={{ fontSize: '22px', cursor: 'pointer', color: '#0056ff' }}
                                                                onClick={() => window.open(this.state.identityCardPath, '_blank')}
                                                                title="View Identity Card"
                                                            />
                                                        </div>
                                                    </div>}
                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2">
                                                            Designation <span className="rad-star text-danger">*</span>
                                                        </label>
                                                        <input type="text" className="form-control"
                                                            value={designation} maxLength={'50'} disabled
                                                            onChange={(e) => this.setState({ designation: e.target.value, designationErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{designationErr}</span>}

                                                    </div>
                                                    {/* <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Photo <span className="rad-star">*</span>
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="photoFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                        />
                                                        {
                                                            photoFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{photoFileErr}</span>}
                                                </div>
                                                <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Photo ID <span className="rad-star">*</span>
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="photoIdFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                        />
                                                        {
                                                            photoIdFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(2)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{photoIdFileErr}</span>}

                                                </div>
                                                <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Fully Vaccination Certificate
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="vaccFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 3)}
                                                        />
                                                        {
                                                            vaccineCertificateFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(3)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                </div> */}
                                                    {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 1</label>
                                                    <input type="text" className="form-control" value={add1}
                                                        onChange={(e) => this.setState({ add1: e.target.value })}
                                                    />
                                                </div> */}
                                                    {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 2</label>
                                                    <input type="text" className="form-control" value={add2}
                                                        onChange={(e) => this.setState({ add2: e.target.value })}
                                                    />
                                                </div> */}
                                                    {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 3</label>
                                                    <input type="text" className="form-control" value={add3}
                                                        onChange={(e) => this.setState({ add3: e.target.value })}
                                                    />
                                                </div> */}
                                                    {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2">
                                                        Country<span className="red-star text-danger">*</span>
                                                    </label>
                                                    <input type="text" className="form-control" value={personalCountry}
                                                        onChange={(e) => this.onPersonalCountrySearch(e)}
                                                    />
                                                    {isDisplayPersonalCountryList && this.renderPersonalCountryList()}
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{personalCountryErr}</span>}
                                                </div> */}
                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2">
                                                            Pincode/Zipcode
                                                            {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                        </label>
                                                        {
                                                            countryId == "91" &&
                                                            <input type="text" className="form-control"
                                                                value={pincode} disabled
                                                                maxLength={6} onChange={(e) => this.onPincodeSearch(e)}
                                                            />
                                                        }
                                                        {
                                                            countryId != "91" &&
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e)}
                                                                onInput={toInputUppercase} disabled
                                                            />
                                                        }
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                        {isDisplayPincodeList && this.renderPincodeList()}
                                                    </div>
                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2">
                                                            State/Province
                                                            {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={regState} maxLength={'50'}
                                                            onChange={(e) => this.onStateSearch(e)} disabled
                                                        />
                                                        {isDisplayStateList && this.renderStateList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regStateErr}</span>}
                                                    </div>

                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2">City
                                                            <span className="red-star text-danger">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={city} maxLength={'50'} disabled
                                                            onChange={(e) => this.onCitySearch(e)} />
                                                        {isDisplayCityList && this.renderCityList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{cityErr}</span>}
                                                    </div>
                                                    <div className="col-sm-3">
                                                        <label className="d-flex mt-2"> Website</label>
                                                        <input type="text" className="form-control"
                                                            value={website} maxLength={'50'} disabled
                                                            onChange={(e) => this.setState({ website: e.target.value })}
                                                        />
                                                    </div>
                                                    {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> GST No</label>
                                                    <input type="text" className="form-control" value={gstNo}
                                                        onChange={(e) => this.setState({ gstNo: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> PAN No</label>
                                                    <input type="text" className="form-control" value={panNo}
                                                        onChange={(e) => this.setState({ panNo: e.target.value })}
                                                    />
                                                </div> */}

                                                    <div className="col-sm-3 mt-2">
                                                        <label className="d-flex">Telephone No</label>

                                                        <div className="input-group">
                                                            {/* STD Code */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={preTelNo}
                                                                disabled
                                                                style={{ maxWidth: "80px" }}
                                                            />

                                                            {/* Telephone Number */}
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                value={telNo}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-3 mt-2">
                                                        <label className="d-flex">Telephone No 1</label>

                                                        <div className="input-group">
                                                            {/* STD Code */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={preTel1No}
                                                                disabled
                                                                style={{ maxWidth: "80px" }}
                                                            />

                                                            {/* Telephone Number */}
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                value={tel1No}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>}
                                        {/* {sessionStorage.getItem('VisitorTypeID') == 2 && <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0">Personal Information</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  {this.renderGroupList()}</div>} */}
                                    </div>
                                </div>
                            </div>
                            <div className="one-section mb-3">
                                <div className="containerfluid">
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg ">
                                                <label className="ms-1 fw-semibold">
                                                    <input type="checkbox" name="fav_language"
                                                        value={this.state.isInvoice} checked={this.state.isInvoice}
                                                        disabled
                                                        onClick={(e) => this.setState({
                                                            isInvoice: !this.state.isInvoice,
                                                            INVPersonNameErr: '',
                                                            INVCompanyNameErr: '',
                                                            INVAddressErr: '',
                                                            INVTanNoErr: '',
                                                            GSTNoErr: '',
                                                            PANNoErr: '',
                                                        })}
                                                    />Invoice Details
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isInvoice && <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-xl-3 mb-1">
                                            <label className="mt-3">Person Incharge Name<span className="text-red">*</span></label>
                                            <input type="text" className="form-control" value={INVPersonName}
                                                disabled
                                                maxLength={'50'}
                                                onChange={(e) => this.setState({ INVPersonName: e.target.value, INVPersonNameErr: "" })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVPersonNameErr}</span>}
                                        </div>
                                        <div className="col-xl-3 mb-1">
                                            <label className="mt-3">Company Name<span className="text-red">*</span></label>
                                            <input type="text" className="form-control" value={INVCompanyName}
                                                disabled
                                                maxLength={'200'}
                                                onChange={(e) => this.setState({ INVCompanyName: e.target.value, INVCompanyNameErr: "" })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVCompanyNameErr}</span>}

                                        </div>
                                        <div className="col-xl-6 mb-1">
                                            <label className="mt-3">Address
                                                <span className="text-red">*</span>
                                            </label>
                                            <input type="text" className="form-control" value={INVAddress} maxLength={'50'}
                                                disabled
                                                onChange={(e) => this.setState({ INVAddress: e.target.value, INVAddressErr: "" })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVAddressErr}</span>}
                                        </div>
                                        {/* <div className="col-xl-3 mb-1"> */}
                                        <div className="col-xl-3 mt -2">
                                            <div className="d-flex">
                                                <label className=" w-auto" >
                                                    Select Country
                                                    <span className="text-red">*</span>

                                                </label>
                                                {/* {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdINVErr}</span>} */}
                                            </div>
                                            <select className="form-control" value={countryIdINV}
                                                disabled
                                            // onChange={(e) => this.onCountrySelectINV(e)}
                                            >
                                                <option value={''}>Select Your Country</option>
                                                {
                                                    countryList.length > 0 && countryList.map((data) => (
                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-sm-3">
                                            <label className="d-flex mt-2">
                                                Pincode/Zipcode
                                                {countryIdINV == "91" && <span className="red-star text-danger">*</span>}
                                            </label>
                                            {
                                                countryIdINV == "91" &&
                                                <input type="text" className="form-control" value={pincodeINV}
                                                    disabled

                                                // maxLength={6} onChange={(e) => this.onPincodeSearchINV(e)}
                                                />
                                            }
                                            {
                                                countryIdINV != "91" &&
                                                <input type="text" className="form-control" value={pincodeINV}
                                                    disabled

                                                    // maxLength={10} onChange={(e) => this.onPincodeSearchINV(e)}
                                                    onInput={toInputUppercase}
                                                />
                                            }
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{pincodeINVErr}</span>} */}
                                            {/* {isDisplayPincodeListINV && this.renderPincodeListINV()} */}
                                        </div>
                                        <div className="col-sm-3">
                                            <label className="d-flex mt-2">
                                                State/Province
                                                {countryIdINV == "91" && <span className="red-star text-danger">*</span>}
                                            </label>
                                            <input type="text" className="form-control" value={regStateINV} maxLength={'50'}
                                                disabled

                                            // onChange={(e) => this.onStateSearchINV(e)}
                                            />
                                            {/* {isDisplayStateListINV && this.renderStateListINV()} */}
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regStateINVErr}</span>} */}
                                        </div>
                                        <div className="col-sm-3">
                                            <label className="d-flex mt-2">City
                                                <span className="red-star text-danger">*</span>
                                            </label>
                                            <input type="text" className="form-control" value={cityINV} maxLength={'50'}
                                                disabled

                                            // onChange={(e) => this.onCitySearchINV(e)} 

                                            />
                                            {/* {isDisplayCityListINV && this.renderCityListINV()} */}
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{cityINVErr}</span>} */}
                                        </div>
                                        <div className="col-xl-3 mb-1">

                                            <label className="mt-3">PAN Number<span className="text-red">*</span></label>
                                            <input type="text" className="form-control" value={PANNo}
                                                maxLength={'50'}
                                                disabled
                                                onChange={(e) => {
                                                    // const errMsg = panNoValidator(e.target.value)
                                                    this.setState({ PANNo: e.target.value, PANNoErr: '' })
                                                    // if (errMsg != '') {
                                                    //     this.setState({
                                                    //         PANNoErr: errMsg,
                                                    //     })
                                                    // } else {
                                                    //     this.setState({
                                                    //         PANNoErr: "",
                                                    //     })
                                                    // }
                                                }
                                                }
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{PANNoErr}</span>}
                                            {/* </div> */}
                                        </div>

                                        <div className="col-xl-3 mb-1">
                                            <label className="mt-3">TAN Number<span className="text-red">*</span></label>
                                            <input type="text" className="form-control" value={INVTanNo}
                                                maxLength={'50'}
                                                disabled
                                                onChange={(e) => {
                                                    // const errMsg = tanNoValidator(e.target.value)
                                                    this.setState({
                                                        INVTanNo: e.target.value,
                                                    })
                                                    // if (errMsg != '') {
                                                    //     this.setState({
                                                    //         INVTanNoErr: errMsg,
                                                    //     })
                                                    // } else {
                                                    //     this.setState({
                                                    //         INVTanNoErr: "",
                                                    //     })
                                                    // }
                                                }}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVTanNoErr}</span>}
                                        </div>
                                        <div className="col-xl-3 mb-1">
                                            <label className="mt-3">GST Number<span className="text-red">*</span></label>
                                            <input type="text" className="form-control" value={GSTNo}
                                                maxLength={'50'}
                                                disabled
                                                onChange={(e) =>
                                                    this.onGSTchange(e.target.value)
                                                }
                                                onInput={toInputUppercase}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{GSTNoErr}</span>}
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            <div className="needs-validation after-step mt-1" style={{ marginTop: 115 }}>
                                <div id="Menu2">
                                    <div className="containerfluid">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="p-1 title-bg d-flex">
                                                    <p className="mb-0 fw-semibold">Industry Segment <span className="text-red">*</span>
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{chapterErr}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" mt-2" id="section-2">
                                        <div className="one-section">
                                            <div className=" mb-2">
                                                <div className="row mt-1">
                                                    <div className="asc">
                                                        <div className="" style={{ paddingLeft: 10 }}>
                                                            <form className="needs-validation pb-2" noValidate="">
                                                                <div className="form-row">
                                                                    {
                                                                        industryChapFilter.length > 0 && industryChapFilter.map((data) => (
                                                                            <div className="col-sm-3">
                                                                                <section className="" key={data.IndustrySegmentID}>
                                                                                    {/* <input type="checkbox" name="collapse"
                                                                                    select={data.IsSelect} checked={data.IsSelect}
                                                                                    value={data.IndustrySegmentID}

                                                                                /> */}
                                                                                    <label>
                                                                                        <input type="checkbox"
                                                                                            select={data.IsSelect} checked={data.IsSelect}
                                                                                            value={data.IndustrySegmentID} disabled
                                                                                            onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                        {data['Industrial Segment']}
                                                                                    </label>
                                                                                </section>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0 fw-semibold">
                                                                Products List <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-xl-12 mb-4">
                                                <div className="row mt-4">
                                                    <div class="accordion" id="accordionExample">
                                                        {
                                                            primaryChapterListData.length > 0 && primaryChapterListData.map((level1Data, i) => (
                                                                <>
                                                                    {
                                                                        <div class="accordion-item">
                                                                            <h2 class="accordion-header check-out" id={'heading_l1_' + level1Data.ChapterID}>

                                                                                <button class={"accordion-button collapsed  tit-name"}
                                                                                    type="button"
                                                                                    data-bs-toggle="collapse"
                                                                                    data-bs-target={'#collapse_l1_' + level1Data.ChapterID} aria-expanded="false"
                                                                                    aria-controls={'collapse_l1_' + level1Data.ChapterID}>
                                                                                    {level1Data.IsCheckbox &&
                                                                                        <input type="checkbox" className="from-left-sp check-out-in" name="" key={level1Data.ChapterID}
                                                                                            checked={level1Data.IsSelect}
                                                                                            onClick={e => this.onCheckLevel1(e, level1Data.ChapterID)}
                                                                                        />
                                                                                    }
                                                                                    {level1Data.ChapterName}
                                                                                </button>
                                                                            </h2>
                                                                            {this.record(level1Data)}
                                                                        </div>
                                                                    }

                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="p-3">
                                                <p className="mb-0 fw-semibold">
                                                    Selected Products List
                                                </p>
                                                {
                                                    filerArray.length > 0 ? filerArray.map((data) => (
                                                        <p className="mb-0">
                                                            {data.ChapterName}
                                                        </p>
                                                    )) :
                                                        <p className="mb-0">
                                                            {"No Results"}
                                                        </p>
                                                }
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0 fw-semibold">
                                                                Purpose of Visit <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 mb-2">
                                                {visitPurposeList.length > 0 && console.log(visitPurposeList, 'pp')}
                                                <div className="row mt-3">
                                                    {
                                                        visitPurposeList.length > 0 && visitPurposeList.map((data) => (<>
                                                            {data.isSelect &&
                                                                <div className="col-sm-3 mb-2" key={data.PurposeofVisitID}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" name="fav_language"
                                                                            select={data.isSelect} checked={data.isSelect}
                                                                            value={data.PurposeofVisitID} disabled
                                                                            onChange={(e) => this.onSelectPurpose(e)}
                                                                        />
                                                                        {data.PurposeofVisitName}
                                                                    </label>

                                                                    {
                                                                        data.PurposeofVisitID == 10 && data.isSelect &&
                                                                        <input
                                                                            className="form-control"
                                                                            maxLength={'100'}
                                                                            value={data.otherDetail}
                                                                            onChange={(e) => this.otherDetailsChange(e)}
                                                                        >
                                                                        </input>
                                                                    }
                                                                </div>}
                                                        </>

                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            isGrpDelegation &&
                                            <div className="one-section mb-3">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Group Delegation<span className="text-red">*</span>
                                                                </p>
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    isGrpDelegation &&
                                                    <div
                                                        className="col-md-12 mb-2"
                                                        id="divMsg"
                                                    >
                                                        <div className="row">
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Delegation Leader/Organisation<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={leader} maxLength={'50'}
                                                                    disabled
                                                                    onChange={(e) => this.setState({ leader: e.target.value, leaderErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{leaderErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Country/Region<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={delegationCountry} disabled
                                                                    onChange={(e) => this.onDelegationCountrySearch(e)}
                                                                />
                                                                {isDisplayDelegationCountryList && this.renderDelegationCountryList()}
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{delegationCountryErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Arrival Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={arrivalDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            arrivalDateErr: ""
                                                                        })}
                                                                    disabled
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Arrival Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Departure Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={departureDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            departureDateErr: ""
                                                                        })}
                                                                    disabled
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Departure Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xl-12 mb-1">
                                                                    <label className="mt-3">Remark
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows={3}
                                                                        maxLength={'250'}
                                                                        defaultValue={""}
                                                                        disabled
                                                                        value={delegationRemark}
                                                                        onChange={(e) => this.setState({ delegationRemark: e.target.value, delegationRemarkErr: "" })}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{delegationRemarkErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {needVisaAssistance &&
                                            <div className="one-section mb-3">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Visa Application<span className="text-red">*</span>
                                                                </p>
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    needVisaAssistance && sessionStorage.getItem('VisitorTypeID') == 1 &&
                                                    <div
                                                        className="col-md-12 mb-2"
                                                        id="divMsg"
                                                    >
                                                        <div className="row">
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Name as per Passport<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={passName} maxLength={'50'} disabled
                                                                    onChange={(e) => this.setState({ passName: e.target.value, passNameErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant mobile number<span className="text-red">*</span>
                                                                </label>
                                                                <input type="number" className="form-control" value={applicantMobNo} disabled
                                                                    style={{ paddingLeft: "50px" }}
                                                                    maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 &&
                                                                        this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "" })}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    disabled
                                                                    className="form-control-1 mt-2"
                                                                    // placeholder="ISD"
                                                                    value={preApplicantMobNo}
                                                                    onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                                    maxLength={'10'}
                                                                    style={{
                                                                        width: 45,
                                                                        position: "absolute",
                                                                        top: 30,
                                                                        padding: " 6px !important",
                                                                        paddingLeft: 5,
                                                                        borderLeft: 0,
                                                                        borderTop: 0,
                                                                        background: "none",
                                                                        borderBottom: 0,
                                                                        height: 34
                                                                    }}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant email id<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={applicantEmail} maxLength={'50'} disabled
                                                                    onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport No
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" disabled className="form-control" value={passNo} maxLength={'10'}
                                                                    onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport issue Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passDate}
                                                                    disabled
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passDateErr: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    maxDate={passExipryDate}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Issued Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport Expiry Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passExipryDate}
                                                                    disabled
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passExipryDateErr: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    minDate={passDate}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Expiry Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Passport issuing Country<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" disabled className="form-control" value={passCountry}
                                                                    onChange={(e) => this.onPassportCountrySearch(e)}
                                                                />
                                                                {isDisplayPassCountryList && this.renderPassCountryList()}
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passCountryErr}</span>}
                                                            </div>
                                                            {!(isPassportFilePresent) &&
                                                                <div className="col-xl-5">
                                                                    <label className="mt-3">
                                                                        Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                        <input type="file" disabled id="passportFile" name="filename"
                                                                            accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                            onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                        />
                                                                        <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                            Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                        </span>
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passportFileErr}</span>}
                                                                        {/* {
                                                                            passportFile != "" &&
                                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                        } */}
                                                                    </form>
                                                                </div>
                                                            }
                                                            {
                                                                isVisaApplied && passportFile != "" && passportFile != null && isPassportFilePresent &&
                                                                <div className="col-xl-5">
                                                                    <label className="mt-3">
                                                                        Passport Front Page File
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <div style={{
                                                                        border: '1px solid #ccc',
                                                                        padding: '10px',
                                                                        // display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        marginTop: '10px',
                                                                        // marginLeft: '12px',
                                                                        maxWidth: '300px'
                                                                    }}>
                                                                        <span style={{ marginRight: '10px' }}
                                                                        >{passPortFileName}</span>
                                                                        {/* <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i> */}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {console.log(this.state.visitorGroupList)}
                                                {
                                                    needVisaAssistance && sessionStorage.getItem('VisitorTypeID') == 2 &&
                                                    //map+all data points
                                                    this.state.visitorGroupList.length > 0 && this.state.visitorGroupList.map((data, i) => (
                                                        <>
                                                            {data.isVisit && < div
                                                                className="list-group-item col-md-12 m-3"
                                                                id="divMsg"
                                                            // style={{backgroundColor:}}
                                                            >
                                                                <div className="row">
                                                                    <h5>{data.isCoordinator ? 'Coordinator' : `Visitor ${i}`}</h5>
                                                                    {console.log('ppp')}
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Name as per Passport<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" disabled className="form-control" value={data.passName} maxLength={'50'}
                                                                            onChange={(e) => this.onInput(e, e.target.value, i, 'name')}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passNameErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant mobile number<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="number" disabled className="form-control" value={data.applicantMobNo}
                                                                            style={{ paddingLeft: "50px" }}
                                                                            maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            className="form-control-1 mt-2"
                                                                            // placeholder="ISD"
                                                                            value={data.preApplicantMobNo}
                                                                            disabled
                                                                            // onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                                            maxLength={'10'}
                                                                            style={{
                                                                                width: 45,
                                                                                position: "absolute",
                                                                                top: 30,
                                                                                padding: " 6px !important",
                                                                                paddingLeft: 5,
                                                                                borderLeft: 0,
                                                                                borderTop: 0,
                                                                                background: "none",
                                                                                borderBottom: 0,
                                                                                height: 34
                                                                            }}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantMobNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant email id<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={data.applicantEmail} maxLength={'50'}
                                                                            disabled
                                                                        // onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantEmailErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport No
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" disabled className="form-control" value={data.passNo} maxLength={'10'}
                                                                            // onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                                            onChange={(e) => this.onInput(e, e.target.value, i, 'passno')}

                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport issue Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={data.passDate} disabled
                                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDate')}
                                                                            // onChange={(date) =>
                                                                            //     this.setState({
                                                                            //         passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            //         passDateErr: ""
                                                                            //     })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            maxDate={data.passExipryDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Issued Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport Expiry Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={data.passExipryDate} disabled
                                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDateEx')}
                                                                            // onChange={(date) =>
                                                                            //     this.setState({
                                                                            //         passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            //         passExipryDateErr: ""
                                                                            //     })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            minDate={data.passDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Expiry Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passExipryDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Passport issuing Country<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={data.passCountry} disabled
                                                                            onChange={(e) => this.onInput(e, e, i, 'passCountry')}

                                                                        />
                                                                        {data.isDisplayPassCountryList && this.renderPassCountryList(i)}
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{data.passCountryErr}</span>}
                                                                    </div>
                                                                    {!(data.isPassportFilePresent) &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                                <input
                                                                                    // type="file" id="passportFile" name="filename"
                                                                                    //     accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                                    //     onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                                    type="file"
                                                                                    id={`path${i}`}
                                                                                    disabled
                                                                                    className="image-upload"
                                                                                    accept=".jpg, .jpeg, .png"
                                                                                    onChange={e => this.onInput(e, e.target.files, i, 'passImg')}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{data.passportFileErr}</span>}
                                                                                {/* {
                                                                                data.passportFile != "" &&
                                                                                <i class="fa fa-times text-danger img-can"
                                                                                    onClick={() => this.onCrossClick(1, i)}
                                                                                ></i>
                                                                            } */}
                                                                            </form>
                                                                        </div>
                                                                    }
                                                                    {
                                                                        isVisaApplied && data.passportFilePath != "" && data.passportFilePath != null && data.isPassportFilePresent &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page File
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <div style={{
                                                                                border: '1px solid #ccc',
                                                                                padding: '10px',

                                                                                // display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                marginTop: '10px',
                                                                                // marginLeft: '12px',
                                                                                maxWidth: '300px'
                                                                            }}>
                                                                                <span style={{ marginRight: '10px' }}
                                                                                >{data.passportFile}</span>
                                                                                {/* <i className="fa fa-times text-danger img-can"
                                                                                onClick={() => this.onCrossClick(1, i)}
                                                                            ></i> */}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>}
                                                        </>
                                                    ))
                                                }
                                            </div>
                                        }
                                        {/* {
                                        !isStudentAttendee &&

                                        <div>
                                            <div>
                                                <p style={{ marginLeft: 12 }} className="mb-2">
                                                    <strong>
                                                        Letter from the employer giving the position of applicant in the
                                                        company, the reason for the visit with particulars of companies
                                                        to be visited.
                                                        <a
                                                            target="_blank"
                                                            href={Visitorletter}
                                                            download="Visitorletter"
                                                        >
                                                            <i
                                                                className="fa fa-file-pdf-o text-primary"
                                                                style={{ fontSize: 17 }}
                                                                aria-hidden="true"
                                                            />
                                                        </a>
                                                    </strong>
                                                </p>
                                                <div className="col-xl-6">
                                                    <label className="">Upload file </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="visitorLetter" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                        />
                                                        {
                                                            visitorLetterFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(2)}></i>
                                                        }
                                                    </form>
                                                    <p>
                                                        <strong>NOTE:</strong> Upload Maximum 1mb Size Only / Allowed
                                                        File Type: pdf
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="one-section ">
                                        <div className="containerfluid">
                                            <div className="row">
                                                <div className="col-md-12 mt-2">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Note</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-12 mb-1">
                                                    <label className="d-flex">
                                                        {" "}
                                                        1. In case you are applying for business visa kindly upload the
                                                        Permission/NOC from your company to travel to ITME Africa &amp; M.E.
                                                        2023 in Kenya
                                                    </label>
                                                </div>
                                                <div className="col-sm-12 mb-2">
                                                    <label className="d-flex">
                                                        {" "}
                                                        2. In case you are applying for non-business visa you need not
                                                        required to upload the document
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        {isAnyInterest &&
                                            <div className="one-section ">
                                                <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12 mt-2">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Interested</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            interestList.length > 0 && interestList.map((data) => (
                                                                <div className="col-sm-12 mb-2" key={data.AreaofInterestID}>
                                                                    {data.isSelect &&
                                                                        <label className="d-flex">
                                                                            <input type="checkbox" name="fav_language" value={data.AreaofInterestID}
                                                                                select={data.isSelect} checked={data.isSelect} disabled
                                                                            // onChange={(e) => this.onSelectInterest(e)}
                                                                            />
                                                                            {data.Name}
                                                                        </label>
                                                                    }
                                                                    {isInterestTwo && data.AreaofInterestID == 2 &&
                                                                        < div >
                                                                            <div className="col-sm-3 ">
                                                                                <label className="d-flex">
                                                                                    <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>If interested Please fill preferred Date & Time</strong>
                                                                                        (Exhibition time is 09:00hrs to 17:00hrs)
                                                                                    </span>
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="col-md-12 mb-2"
                                                                                id="divMsg"
                                                                            >
                                                                                <div className="row">
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-1">Date
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <DatePicker selected={preffDate}
                                                                                            onChange={(date) =>
                                                                                                this.setState({
                                                                                                    preffDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                    preffDateErr: ""
                                                                                                })}
                                                                                            disabled
                                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                            peekNextMonth
                                                                                            showMonthDropdown
                                                                                            showYearDropdown
                                                                                            dropdownMode="select"
                                                                                            placeholderText="Preferred Date"
                                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                                            popperClassName="example-datepicker-class" />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{preffDateErr}</span>}
                                                                                        <div>
                                                                                            <div >
                                                                                                <label>preferred Time:</label>
                                                                                                <input
                                                                                                    type="time"
                                                                                                    className="form-control"
                                                                                                    value={prefTime}
                                                                                                    disabled
                                                                                                    onChange={(e) => this.handlePrefTime(e)}
                                                                                                />
                                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{preffTimeErr}</span>}
                                                                                            </div>

                                                                                        </div>

                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-xl-8 mb-1">
                                                                                            <label className="mt-1">Remark
                                                                                            </label>
                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows={3}
                                                                                                maxLength={'250'}
                                                                                                defaultValue={""}
                                                                                                value={b2bRemark}
                                                                                                disabled
                                                                                                onChange={(e) => this.setState({ b2bRemark: e.target.value, b2bRemarkErr: "" })}
                                                                                            />
                                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{b2bRemarkErr}</span>}
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {isInterstOne && data.AreaofInterestID == 1 &&
                                                                        <div className="table-responsive" >
                                                                            <table className="table border table-bordered mb-0 mt-1" >
                                                                                <thead>
                                                                                    <tr>
                                                                                        {/* <th className="text-center">Day</th> */}
                                                                                        <th style={{ width: '180px' }}>Date & Time</th>
                                                                                        <th >Session Name</th>
                                                                                        {/* <th style={{ width: '380px' }}>Speaker</th> */}
                                                                                        <th className="text-center"></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        seminarInterestFilter.length > 0 && seminarInterestFilter.map((data) => (
                                                                                            <tr key={Math.random()}>
                                                                                                {/* <td className={data.ParentSeminarID != 0 ? "text-center" : "fw-bold"}>{data.Day}</td> */}
                                                                                                <td className={data.ParentSeminarID != 0 ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                                                <td className={data.ParentSeminarID != 0 ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}</td>
                                                                                                {/* {data.SeminarID != 14 ? (
                                                                                                    <td>{data.Speaker}</td>
                                                                                                ) : (
                                                                                                    <td>{data.Speaker.split('==').map(item => (
                                                                                                        <tr className="text-start">{item}</tr>
                                                                                                    ))}</td>
                                                                                                )} */}
                                                                                                <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }} className="text-center">
                                                                                                    {data.ParentSeminarID != 0 &&
                                                                                                        data.SeminarTypeID == 1 ? <input type="checkbox"
                                                                                                            value={data.isSelect}
                                                                                                            checked={data.isSelect}
                                                                                                            disabled
                                                                                                            onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                    /> : data.SeminarTypeID == 2 ? <span>
                                                                                                        <strong>Request for Invite</strong>
                                                                                                    </span> :
                                                                                                        <span>
                                                                                                            Seminar Charges: <strong>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD}</strong>
                                                                                                        </span>
                                                                                                    }
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>

                                                                            <div />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {needVisaAssistance &&
                                                    <div className="one-section mb-3">
                                                        <div className="col-sm-3 ">
                                                            <label className="d-flex">
                                                                <input className="do-you" style={{ marginBottom: '25px' }}
                                                                    type="checkbox"
                                                                    name="fav_language"
                                                                    checked={needVisaAssistance}
                                                                    disabled
                                                                    onChange={(e) => this.setState({
                                                                        needVisaAssistance: !needVisaAssistance,
                                                                        isVisaUpdated: false
                                                                    })}
                                                                />
                                                                <span className="do-you1" style={{ whiteSpace: "nowrap" }}><strong>Do you need Visa Assistance?</strong>
                                                                    (<b>Note</b> : Visa Application letter will be issued from 1st October 2023. Visitor can avail tourist visa also to attend the exhibition.In case applying for Business visa kindly<br /> fill the below details to obtain Visa Invitation Letter.)</span>
                                                            </label>
                                                        </div>
                                                        {
                                                            needVisaAssistance &&
                                                            <div
                                                                className="col-md-12 mb-2"
                                                                id="divMsg"
                                                            >
                                                                <div className="row">
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Name as per Passport<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                            disabled
                                                                            onChange={(e) => this.setState({ passName: e.target.value, passNameErr: "", isVisaUpdated: true })}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant mobile number<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="number" className="form-control" value={applicantMobNo}
                                                                            style={{ paddingLeft: "50px" }}
                                                                            maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                            onPaste={(e) => this.handlePaste(e)} disabled
                                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                            onChange={(e) => e.target.value >= 0 &&
                                                                                this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "", isVisaUpdated: true })}
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            className="form-control-1 mt-2"
                                                                            // placeholder="ISD"
                                                                            value={preApplicantMobNo}
                                                                            disabled
                                                                            onChange={(e) => this.setState({ preApplicantMobNo: e.target.value, isVisaUpdated: true })}
                                                                            style={{
                                                                                width: 45,
                                                                                position: "absolute",
                                                                                top: 30,
                                                                                padding: " 6px !important",
                                                                                paddingLeft: 5,
                                                                                borderLeft: 0,
                                                                                borderTop: 0,
                                                                                background: "none",
                                                                                borderBottom: 0,
                                                                                height: 34
                                                                            }}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant email id<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                            onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "", isVisaUpdated: true })}
                                                                            disabled
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport No
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                            onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "", isVisaUpdated: true })}
                                                                            disabled
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport issue Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={passDate}
                                                                            value={passDate}
                                                                            disabled
                                                                            onChange={(date) =>
                                                                                this.setState({
                                                                                    passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                    passDateErr: "", isVisaUpdated: true
                                                                                })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            maxDate={passExipryDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Issued Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport Expiry Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={passExipryDate}
                                                                            value={passExipryDate}
                                                                            disabled
                                                                            onChange={(date) =>
                                                                                this.setState({
                                                                                    passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                    passExipryDateErr: "", isVisaUpdated: true
                                                                                })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            minDate={passDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Expiry Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Passport issuing Country<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passCountry} disabled
                                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                                        />
                                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passCountryErr}</span>}
                                                                    </div>
                                                                    {!(isPassportFilePresent) &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                                <input type="file" id="passportFile" name="filename"
                                                                                    accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                                    disabled
                                                                                    onChange={e => this.onFilePick(e, e.target.files, 1)}

                                                                                />
                                                                                <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                                    Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                                </span>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportFileErr}</span>}
                                                                                {
                                                                                    passportFile != "" &&
                                                                                    <i className="fa fa-times text-danger img-can"
                                                                                    // onClick={() => this.onCrossClick(1)}
                                                                                    ></i>
                                                                                }
                                                                            </form>
                                                                        </div>
                                                                    }
                                                                    {
                                                                        isVisaApplied && passportFile != "" && passportFile != null && isPassportFilePresent &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page File
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <div style={{
                                                                                border: '1px solid #ccc',
                                                                                padding: '10px',
                                                                                // display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                marginTop: '10px',
                                                                                // marginLeft: '12px',
                                                                                maxWidth: '300px'
                                                                            }}>
                                                                                <span style={{ marginRight: '10px' }}
                                                                                >{passPortFileName}</span>
                                                                                <i className="fa fa-times text-danger img-can"
                                                                                //  onClick={() => this.onCrossClick(1)}
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {/* <div className="one-section">
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Car Parking Required (Paid Service)</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "Yes"}
                                                            onChange={(e) => this.setState({ carParking: "Yes" })}
                                                        />
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "No"}
                                                            onChange={(e) => this.setState({ carParking: "No" })}
                                                        />
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {isParkingAvailable &&
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Car Parking</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-2">
                                                        <div className="col-sm-1">
                                                            <label className="d-flex" htmlFor="carParkingYes">
                                                                {" "}
                                                                <input type="radio" name="billingRadio"
                                                                    id="carParkingYes"
                                                                    disabled={true}
                                                                    checked={isCarParking == 1}
                                                                    onChange={(e) => this.setState({ isCarParking: 1 })}
                                                                />
                                                                <strong>Yes</strong>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-1">
                                                            <label className="d-flex" htmlFor="carParkingNo">
                                                                {" "}
                                                                <input type="radio" name="billingRadio"
                                                                    id="carParkingNo"
                                                                    disabled={true}
                                                                    checked={isCarParking == 0}
                                                                    onChange={(e) => this.setState({ isCarParking: 0 })}
                                                                />
                                                                <strong>No</strong>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {isParkingChargable && isCarParking == 1 &&
                                                        <div className="row mt-3 left-align">
                                                            <strong>Car Parking Charges:- {parkingCharges}</strong>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0 fw-semibold">Remarks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 mb-4">
                                                <div className="row mt-2">
                                                    <div className="col-xl-12 mb-1">
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            maxLength={'250'}
                                                            defaultValue={""}
                                                            value={remarks}
                                                            disabled
                                                            onChange={(e) => this.setState({ remarks: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {console.log(JSON.parse(sessionStorage.getItem("isExhibitionFree")), 'isExhibitionFree')}
                                        <div className="one-section">
                                            <label className="term">
                                                <input
                                                    type="checkbox"
                                                    className="mt-1 d-flex"
                                                    style={{ float: "left" }}
                                                    checked={isAgree}
                                                    disabled
                                                    onChange={(e) => this.setState({ isAgree: !isAgree })}
                                                />
                                                I have read and accept the Visitor
                                                <a>Terms &amp; Conditions &amp; Privacy Policy</a> on this
                                                website and agree to register as visitor. By Submitting my registration, I give my consent to India
                                                ITME Society to verify the provided information submitted by me online
                                                by telephonic call or by Email and also to send me promotional
                                                information via digital and offline channels not limited to email,
                                                SMS, WhatsApp, print newsletter and invitation card.
                                            </label>
                                        </div>
                                        {!JSON.parse(sessionStorage.getItem("isExhibitionFree")) && <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0">Payment Details <span className="text-danger">(convenience fees will be applicable at payment stage.)</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-xl-3 mb-4 mt-2" style={{ float: "right" }}>
                                                <div className="row d-flex" >
                                                    <input type="text" className="form-control" />
                                                    <button class="btn btn-primary" >
                                                        <a className=""  >
                                                            Apply</a>
                                                    </button>
                                                </div>

                                            </div> */}
                                            {<div className="one-section">

                                                <div className="container-fluid">
                                                    {/* Promo Code Section */}
                                                    <div className="row">
                                                        <div className="col-md-4 mt-2">
                                                            <label>Promo Code</label>
                                                            <div className="d-flex">
                                                                <input
                                                                    type="text"
                                                                    className="form-control rounded-0 me-2"
                                                                    disabled={isPromoApply}
                                                                    value={promoCode}
                                                                    onChange={(e) => this.setState({ promoCode: e.target.value.trim() })}
                                                                />
                                                                {isPromoApply ? (
                                                                    <button
                                                                        className="btn btn-gray"
                                                                        onClick={() => this.onCancelPromo()}
                                                                    >
                                                                        Back
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-aqua"
                                                                        onClick={() => this.onApplyPromo()}
                                                                    >
                                                                        Apply
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Charges Grid Section */}
                                                    <div className="row mt-4">
                                                        <div className="col-md-4">
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">Visitor Registration Charges</h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{visitorCharges}</h5>
                                                                </div>
                                                                <div className="col-xl-9" style={{ paddingRight: 0 }}>
                                                                    <div className="d-flex justify-content-between mb-2" style={{ padding: 0 }}>
                                                                        {/* <p className="col-md-6"><strong>Visit Days</strong></p> */}
                                                                        <strong>
                                                                            <p style={{ padding: 0, textAlign: 'left' }}>({paymentDatesList.map((item, i) => (
                                                                                <>
                                                                                    &nbsp;{item}{i != paymentDatesList.length - 1 && ','}  &nbsp;{i == 2 && <br></br>}
                                                                                </>
                                                                            ))})</p>
                                                                        </strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {promoCodeDiscount != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">Promo Code Discount({discountpercent}%)</h5>
                                                                        <h5 className="mb-0 text-danger">-{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.promoCodeDiscount}</h5>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {promoCodeDiscount != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">Total Taxable </h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totaltaxable}</h5>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {this.state.seminarCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">Seminar Charges </h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.seminarCharges}</h5>
                                                                    </div>
                                                                    <div className="col-xl-9" style={{ paddingRight: 0 }}>
                                                                        <div className="d-flex justify-content-between mb-2" style={{ padding: 0 }}>
                                                                            {/* <p className="col-md-6"><strong>Visit Days</strong></p> */}
                                                                            <strong>
                                                                                <p style={{ padding: 0, textAlign: 'left' }}>({seminarChargesShowList.map((item, i) => (
                                                                                    <>
                                                                                        &nbsp;{item}{i != seminarChargesShowList.length - 1 && ','}  &nbsp;{i == 2 && <br></br>}
                                                                                    </>
                                                                                ))})</p>
                                                                            </strong>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/* {isParkingAvailable && isCarParking != 0 && parkingCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="col-6">
                                                                        <h6>Parking Charges</h6>
                                                                    </div>
                                                                    <div className="col-6 text-end">
                                                                        <h6>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{isCarParking ? parkingCharges : 0}</h6>
                                                                    </div>
                                                                </div>
                                                            )} */}

                                                            {this.state.CGST != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">CGST</h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.CGST}</h5>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {this.state.SGST != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">SGST</h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.SGST}</h5>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {this.state.IGST != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">IGST</h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.IGST}</h5>
                                                                    </div>
                                                                </div>
                                                            )}


                                                            <div className="row mt-n2">
                                                                <div className="col-md-12">
                                                                    <hr />
                                                                </div>
                                                            </div>
                                                            <div className="row  " >
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>Total Charges</h6>
                                                                    <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totalCharges}</h6>
                                                                </div>
                                                            </div>

                                                            {/* <div className="row border-top pt-2 mt-2 align-items-start">
                                                                
                                                                <div className="col-6">
                                                                    <h5>Total Charges</h5>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h5>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{totalCharges}</h5>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </div>

                                                    {/* Remark Section */}
                                                    {/* <div className="row">
                                                        <div className="col-md-4 mt-3">
                                                            <label>Remark</label>
                                                            <textarea
                                                                className="form-control"
                                                                value={this.state.remark}
                                                                onChange={(e) => this.setState({ remark: e.target.value })}
                                                            />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            }

                                        </div>}
                                        <div className="main-container m-3">
                                            <div className="mt-1 mb-4 d-flex">
                                                <a
                                                    className="btn btn-aqua me-2"
                                                    type="submit"
                                                    onClick={(e) => this.onPrevClick(e)}
                                                >
                                                    Previous
                                                </a>
                                                {true ? <div>  <button type="btn" class="btn btn-aqua"
                                                    onClick={(e) => this.togglePGCharges(1)}

                                                // disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} 
                                                // Sstyle={{ border: 'none', borderRadius: '2px', scale: '1.2' }}
                                                >
                                                    {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                                                    Submit
                                                    {/* </span> */}
                                                    {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                                                </button></div> :
                                                    <form
                                                        // onSubmit={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [e] })}
                                                        onSubmit={(e) => this.onPreviewSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"

                                                        // action={paymentPortalLink}
                                                        action={this.state.paymentLink}
                                                    >

                                                        {/* <input type="hidden" id="encRequest" name="encRequest"
                                                        value={encPayload} />
                                                    <input type="hidden" name="access_code" id="access_code"
                                                        value={paymentAccessCode} /> */}
                                                        <button type="btn" class="btn btn-aqua">
                                                            Submit
                                                        </button>
                                                    </form>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {sessionStorage.getItem('VisitorTypeID') == 2 && <div className="combine-section">
                            <div className="needs-validation after-step mt-1 " style={{ marginTop: 115 }}>
                                <div id="Menu1">
                                    <div id="section-1">
                                        {/* <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg" style={{ marginTop: "10px" }}>
                                                            <p className="mb-0">Country</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <div className="d-flex">
                                                    <label className="mt-3 w-auto" >
                                                        Select Country
                                                        <span className="text-red">*</span>

                                                    </label>
                                                </div>
                                                <select className="form-control"
                                                    value={countryId} disabled={true}
                                                >
                                                    <option>Select Your Country</option>
                                                    {
                                                        countryList.length > 0 && countryList.map((data) => (
                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div> */}
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">
                                                                Visitor Type <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'></span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 mb-4">
                                                <div className="row mt-4">
                                                    {
                                                        this.state.visitorTypeList.length > 0 && this.state.visitorTypeList.map((data) => (
                                                            <div className="col-sm-4" key={data.VisitorTypeID}>
                                                                <label className="d-flex">
                                                                    <input type="radio" name="vistorType" value={data.VisitorTypeID}
                                                                        checked={data.VisitorTypeID == this.state.VisitorTypeID} disabled
                                                                        // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                                        onChange={(e) => this.setState({ VisitorTypeID: data.VisitorTypeID, GroupDetailsList: [] })}
                                                                    />
                                                                    {data.VisitorType}
                                                                </label>
                                                            </div>
                                                        ))
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">
                                                                Attendee Type <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{attendeeTypeErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-8 mb-4">
                                                <div className="row mt-4">
                                                    {
                                                        attendeeList.length > 0 && attendeeList.map((data) => (
                                                            <>
                                                                {
                                                                    data.isChecked &&
                                                                    <div className="col-sm-4" key={data.AttendeeTypeID}>
                                                                        <label className="d-flex">
                                                                            <input type="radio" name="attendeeType" value={data.AttendeeTypeID}
                                                                                checked={data.isChecked} disabled={true}
                                                                                onChange={(e) => this.onAttendeeSelect(e)}
                                                                            />
                                                                            {data.AttendeeTypeName}
                                                                        </label>
                                                                    </div>
                                                                }
                                                            </>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {sessionStorage.getItem('VisitorTypeID') == 2 && <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0 fw-semibold">Personal Information</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>  {this.renderGroupList(finalArr)}</div>}

                                        <div style={{ height: 20 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="needs-validation after-step mt-1" style={{ marginTop: 115 }}>
                                <div id="Menu2">
                                    <div className=" mt-2" id="section-2">
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">
                                                                Purpose of Visit <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 mb-2">
                                                {visitPurposeList.length > 0 && console.log(visitPurposeList, 'pp')}
                                                <div className="row mt-3">
                                                    {
                                                        visitPurposeList.length > 0 && visitPurposeList.map((data) => (<>
                                                            {data.isSelect &&
                                                                <div className="col-sm-3 mb-2" key={data.PurposeofVisitID}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" name="fav_language"
                                                                            select={data.isSelect} checked={data.isSelect}
                                                                            value={data.PurposeofVisitID} disabled
                                                                            onChange={(e) => this.onSelectPurpose(e)}
                                                                        />
                                                                        {data.PurposeofVisitName}
                                                                    </label>

                                                                    {
                                                                        data.PurposeofVisitID == 10 && data.isSelect &&
                                                                        <input
                                                                            className="form-control"
                                                                            maxLength={'100'}
                                                                            value={data.otherDetail}
                                                                            onChange={(e) => this.otherDetailsChange(e)}
                                                                        >
                                                                        </input>
                                                                    }
                                                                </div>}
                                                        </>

                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            false &&
                                            <div className="one-section mb-3">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Group Delegation<span className="text-red">*</span>
                                                                </p>
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    isGrpDelegation &&
                                                    <div
                                                        className="col-md-12 mb-2"
                                                        id="divMsg"
                                                    >
                                                        <div className="row">
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Delegation Leader/Organisation<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={leader} maxLength={'50'}
                                                                    disabled
                                                                    onChange={(e) => this.setState({ leader: e.target.value, leaderErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{leaderErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Country/Region<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={delegationCountry} disabled
                                                                    onChange={(e) => this.onDelegationCountrySearch(e)}
                                                                />
                                                                {isDisplayDelegationCountryList && this.renderDelegationCountryList()}
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{delegationCountryErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Arrival Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={arrivalDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            arrivalDateErr: ""
                                                                        })}
                                                                    disabled
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Arrival Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Departure Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={departureDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            departureDateErr: ""
                                                                        })}
                                                                    disabled
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Departure Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xl-12 mb-1">
                                                                    <label className="mt-3">Remark
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows={3}
                                                                        maxLength={'250'}
                                                                        defaultValue={""}
                                                                        disabled
                                                                        value={delegationRemark}
                                                                        onChange={(e) => this.setState({ delegationRemark: e.target.value, delegationRemarkErr: "" })}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{delegationRemarkErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        {/* {
                                        !isStudentAttendee &&

                                        <div>
                                            <div>
                                                <p style={{ marginLeft: 12 }} className="mb-2">
                                                    <strong>
                                                        Letter from the employer giving the position of applicant in the
                                                        company, the reason for the visit with particulars of companies
                                                        to be visited.
                                                        <a
                                                            target="_blank"
                                                            href={Visitorletter}
                                                            download="Visitorletter"
                                                        >
                                                            <i
                                                                className="fa fa-file-pdf-o text-primary"
                                                                style={{ fontSize: 17 }}
                                                                aria-hidden="true"
                                                            />
                                                        </a>
                                                    </strong>
                                                </p>
                                                <div className="col-xl-6">
                                                    <label className="">Upload file </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="visitorLetter" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                        />
                                                        {
                                                            visitorLetterFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(2)}></i>
                                                        }
                                                    </form>
                                                    <p>
                                                        <strong>NOTE:</strong> Upload Maximum 1mb Size Only / Allowed
                                                        File Type: pdf
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="one-section ">
                                        <div className="containerfluid">
                                            <div className="row">
                                                <div className="col-md-12 mt-2">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Note</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-12 mb-1">
                                                    <label className="d-flex">
                                                        {" "}
                                                        1. In case you are applying for business visa kindly upload the
                                                        Permission/NOC from your company to travel to ITME Africa &amp; M.E.
                                                        2023 in Kenya
                                                    </label>
                                                </div>
                                                <div className="col-sm-12 mb-2">
                                                    <label className="d-flex">
                                                        {" "}
                                                        2. In case you are applying for non-business visa you need not
                                                        required to upload the document
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        {isAnyInterest &&
                                            <div className="one-section ">
                                                <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12 mt-2">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Interested</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            interestList.length > 0 && interestList.map((data) => (
                                                                <div className="col-sm-12 mb-2" key={data.AreaofInterestID}>
                                                                    {data.isSelect &&
                                                                        <label className="d-flex">
                                                                            <input type="checkbox" name="fav_language" value={data.AreaofInterestID}
                                                                                select={data.isSelect} checked={data.isSelect} disabled
                                                                            // onChange={(e) => this.onSelectInterest(e)}
                                                                            />
                                                                            {data.Name}
                                                                        </label>
                                                                    }
                                                                    {isInterestTwo && data.AreaofInterestID == 2 &&
                                                                        < div >
                                                                            <div className="col-sm-3 ">
                                                                                <label className="d-flex">
                                                                                    <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>If interested Please fill preferred Date & Time</strong>
                                                                                        (Exhibition time is 09:00hrs to 17:00hrs)
                                                                                    </span>
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="col-md-12 mb-2"
                                                                                id="divMsg"
                                                                            >
                                                                                <div className="row">
                                                                                    <div className="col-xl-3">
                                                                                        <label className="mt-1">Date
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <DatePicker selected={preffDate}
                                                                                            onChange={(date) =>
                                                                                                this.setState({
                                                                                                    preffDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                    preffDateErr: ""
                                                                                                })}
                                                                                            disabled
                                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                            peekNextMonth
                                                                                            showMonthDropdown
                                                                                            showYearDropdown
                                                                                            dropdownMode="select"
                                                                                            placeholderText="Preferred Date"
                                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                                            popperClassName="example-datepicker-class" />
                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{preffDateErr}</span>}
                                                                                        <div>
                                                                                            <div >
                                                                                                <label>preferred Time:</label>
                                                                                                <input
                                                                                                    type="time"
                                                                                                    className="form-control"
                                                                                                    value={prefTime}
                                                                                                    disabled
                                                                                                    onChange={(e) => this.handlePrefTime(e)}
                                                                                                />
                                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{preffTimeErr}</span>}
                                                                                            </div>

                                                                                        </div>

                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-xl-8 mb-1">
                                                                                            <label className="mt-1">Remark
                                                                                            </label>
                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows={3}
                                                                                                maxLength={'250'}
                                                                                                defaultValue={""}
                                                                                                value={b2bRemark}
                                                                                                disabled
                                                                                                onChange={(e) => this.setState({ b2bRemark: e.target.value, b2bRemarkErr: "" })}
                                                                                            />
                                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{b2bRemarkErr}</span>}
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {isInterstOne && data.AreaofInterestID == 1 &&
                                                                        <div className="table-responsive" >
                                                                            <table className="table border table-bordered mb-0 mt-1" >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-center">Day</th>
                                                                                        <th style={{ width: '180px' }}>Date & Time</th>
                                                                                        <th style={{ width: '680px' }}>Description</th>
                                                                                        <th style={{ width: '380px' }}>Speaker</th>
                                                                                        <th className="text-center"></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        seminarInterestFilter.length > 0 && seminarInterestFilter.map((data) => (
                                                                                            <tr key={Math.random()}>
                                                                                                <td className={data.ParentSeminarID != 0 ? "text-center" : "fw-bold"}>{data.Day}</td>
                                                                                                <td className={data.ParentSeminarID != 0 ? null : "fw-bold"}>{data['Date & Time']}</td>
                                                                                                <td className={data.ParentSeminarID != 0 ? null : "fw-bold"}>{data.Description}</td>
                                                                                                {data.SeminarID != 14 ? (
                                                                                                    <td>{data.Speaker}</td>
                                                                                                ) : (
                                                                                                    <td>{data.Speaker.split('==').map(item => (
                                                                                                        <tr className="text-start">{item}</tr>
                                                                                                    ))}</td>
                                                                                                )}
                                                                                                <td className="text-center">
                                                                                                    {data.ParentSeminarID != 0 &&
                                                                                                        <input type="checkbox"
                                                                                                            value={data.isSelect}
                                                                                                            checked={data.isSelect}
                                                                                                            disabled
                                                                                                            onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                        />
                                                                                                    }
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>

                                                                            <div />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {false &&
                                                    <div className="one-section mb-3">
                                                        <div className="col-sm-3 ">
                                                            <label className="d-flex">
                                                                <input className="do-you" style={{ marginBottom: '25px' }}
                                                                    type="checkbox"
                                                                    name="fav_language"
                                                                    checked={needVisaAssistance}
                                                                    disabled
                                                                    onChange={(e) => this.setState({
                                                                        needVisaAssistance: !needVisaAssistance,
                                                                        isVisaUpdated: false
                                                                    })}
                                                                />
                                                                <span className="do-you1" style={{ whiteSpace: "nowrap" }}><strong>Do you need Visa Assistance?</strong>
                                                                    (<b>Note</b> : Visa Application letter will be issued from 1st October 2023. Visitor can avail tourist visa also to attend the exhibition.In case applying for Business visa kindly<br /> fill the below details to obtain Visa Invitation Letter.)</span>
                                                            </label>
                                                        </div>
                                                        {
                                                            needVisaAssistance &&
                                                            <div
                                                                className="col-md-12 mb-2"
                                                                id="divMsg"
                                                            >
                                                                <div className="row">
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Name as per Passport<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                            disabled
                                                                            onChange={(e) => this.setState({ passName: e.target.value, passNameErr: "", isVisaUpdated: true })}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant mobile number<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="number" className="form-control" value={applicantMobNo}
                                                                            style={{ paddingLeft: "50px" }}
                                                                            maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                            onPaste={(e) => this.handlePaste(e)} disabled
                                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                            onChange={(e) => e.target.value >= 0 &&
                                                                                this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "", isVisaUpdated: true })}
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            className="form-control-1 mt-2"
                                                                            // placeholder="ISD"
                                                                            value={preApplicantMobNo}
                                                                            disabled
                                                                            onChange={(e) => this.setState({ preApplicantMobNo: e.target.value, isVisaUpdated: true })}
                                                                            style={{
                                                                                width: 45,
                                                                                position: "absolute",
                                                                                top: 30,
                                                                                padding: " 6px !important",
                                                                                paddingLeft: 5,
                                                                                borderLeft: 0,
                                                                                borderTop: 0,
                                                                                background: "none",
                                                                                borderBottom: 0,
                                                                                height: 34
                                                                            }}
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Applicant email id<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                            onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "", isVisaUpdated: true })}
                                                                            disabled
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport No
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                            onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "", isVisaUpdated: true })}
                                                                            disabled
                                                                        />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport issue Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={passDate}
                                                                            value={passDate}
                                                                            disabled
                                                                            onChange={(date) =>
                                                                                this.setState({
                                                                                    passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                    passDateErr: "", isVisaUpdated: true
                                                                                })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            maxDate={passExipryDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Issued Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">Passport Expiry Date
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <DatePicker selected={passExipryDate}
                                                                            value={passExipryDate}
                                                                            disabled
                                                                            onChange={(date) =>
                                                                                this.setState({
                                                                                    passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                    passExipryDateErr: "", isVisaUpdated: true
                                                                                })}
                                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            minDate={passDate}
                                                                            dropdownMode="select"
                                                                            placeholderText="Passport Expiry Date"
                                                                            dayClassName={() => "example-datepicker-day-class"}
                                                                            popperClassName="example-datepicker-class" />
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label className="mt-3">
                                                                            Passport issuing Country<span className="text-red">*</span>
                                                                        </label>
                                                                        <input type="text" className="form-control" value={passCountry} disabled
                                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                                        />
                                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passCountryErr}</span>}
                                                                    </div>
                                                                    {!(isPassportFilePresent) &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                                <input type="file" id="passportFile" name="filename"
                                                                                    accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                                    disabled
                                                                                    onChange={e => this.onFilePick(e, e.target.files, 1)}

                                                                                />
                                                                                <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                                    Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                                </span>
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportFileErr}</span>}
                                                                                {
                                                                                    passportFile != "" &&
                                                                                    <i className="fa fa-times text-danger img-can"
                                                                                    // onClick={() => this.onCrossClick(1)}
                                                                                    ></i>
                                                                                }
                                                                            </form>
                                                                        </div>
                                                                    }
                                                                    {
                                                                        isVisaApplied && passportFile != "" && passportFile != null && isPassportFilePresent &&
                                                                        <div className="col-xl-5">
                                                                            <label className="mt-3">
                                                                                Passport Front Page File
                                                                                <span className="text-red">*</span>
                                                                            </label>
                                                                            <div style={{
                                                                                border: '1px solid #ccc',
                                                                                padding: '10px',
                                                                                // display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                marginTop: '10px',
                                                                                // marginLeft: '12px',
                                                                                maxWidth: '300px'
                                                                            }}>
                                                                                <span style={{ marginRight: '10px' }}
                                                                                >{passPortFileName}</span>
                                                                                <i className="fa fa-times text-danger img-can"
                                                                                //  onClick={() => this.onCrossClick(1)}
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {/* <div className="one-section">
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Car Parking Required (Paid Service)</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "Yes"}
                                                            onChange={(e) => this.setState({ carParking: "Yes" })}
                                                        />
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "No"}
                                                            onChange={(e) => this.setState({ carParking: "No" })}
                                                        />
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {isParkingAvailable &&
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Car Parking</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-2">
                                                        <div className="col-sm-1">
                                                            <label className="d-flex" htmlFor="carParkingYes">
                                                                {" "}
                                                                <input type="radio" name="billingRadio"
                                                                    id="carParkingYes"
                                                                    disabled={true}
                                                                    checked={isCarParking == 1}
                                                                    onChange={(e) => this.setState({ isCarParking: 1 })}
                                                                />
                                                                <strong>Yes</strong>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-1">
                                                            <label className="d-flex" htmlFor="carParkingNo">
                                                                {" "}
                                                                <input type="radio" name="billingRadio"
                                                                    id="carParkingNo"
                                                                    disabled={true}
                                                                    checked={isCarParking == 0}
                                                                    onChange={(e) => this.setState({ isCarParking: 0 })}
                                                                />
                                                                <strong>No</strong>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {isParkingChargable && isCarParking == 1 &&
                                                        <div className="row mt-3 left-align">
                                                            <strong>Car Parking Charges:- {parkingCharges}</strong>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0">Remarks</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 mb-4">
                                                <div className="row mt-2">
                                                    <div className="col-xl-12 mb-1">
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            maxLength={'250'}
                                                            defaultValue={""}
                                                            value={remarks}
                                                            disabled
                                                            onChange={(e) => this.setState({ remarks: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="col-xl-12 mb-4">
                                                <div className="mt-2">
                                                    <div className="col-sm-12 mb-2">

                                                        <label className="term">
                                                            <input
                                                                type="checkbox"
                                                                className="mt-1 d-flex"
                                                                style={{ float: "left" }}
                                                                checked={isAgree}
                                                                disabled
                                                                onChange={(e) => this.setState({ isAgree: !isAgree })}
                                                            />
                                                            I have read and accept the Visitor
                                                            <a>Terms &amp; Conditions &amp; Privacy Policy</a> on this
                                                            website and agree to register as visitor. By Submitting my registration, I give my consent to India
                                                            ITME Society to verify the provided information submitted by me online
                                                            by telephonic call or by Email and also to send me promotional
                                                            information via digital and offline channels not limited to email,
                                                            SMS, WhatsApp, print newsletter and invitation card.
                                                        </label>
                                                    </div>
                                                    {/* <div className="col-sm-12 mb-2">
                                                        <input
                                                            type="checkbox"
                                                            className="mt-1 d-flex"
                                                            style={{ float: "left" }}
                                                            checked={true}
                                                            disabled
                                                        />
                                                        <label className="term">
                                                            By providing your contact details in this registration form, you agree to receive regular updates about our events and programs via email and WhatsApp. Your information will be used solely for this purpose and will not be shared with third parties. You can opt-out of these communications at any time by following the unsubscribe instructions provided in the messages.
                                                        </label>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        {!JSON.parse(sessionStorage.getItem("isExhibitionFree")) && <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0">Payment Details <span className="text-danger">(convenience fees will be applicable at payment stage.)</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-xl-3 mb-4 mt-2" style={{ float: "right" }}>
                                                <div className="row d-flex" >
                                                    <input type="text" className="form-control" />
                                                    <button class="btn btn-primary" >
                                                        <a className=""  >
                                                            Apply</a>
                                                    </button>
                                                </div>

                                            </div> */}
                                            {<div className="container-fluid">
                                                <div className="row" >
                                                    <div style={{ textAlign: 'left' }} className="col-md-4 mt-2">
                                                        <label>Promo Code</label>
                                                        <div className="d-flex">
                                                            <input type="text" className="form-control rounded-0" style={{ marginRight: '5px' }}
                                                                disabled={isPromoApply} value={promoCode} onChange={(e) => this.setState({ promoCode: e.target.value })}
                                                            />
                                                            {isPromoApply ?
                                                                <button className="btn btn-primary text-white rounded-0"
                                                                    onClick={() => this.onCancelPromo()}
                                                                >
                                                                    <a className="text-white" >
                                                                        Back
                                                                    </a>
                                                                </button>
                                                                :
                                                                <button className="btn btn-primary rounded-0"
                                                                    onClick={() => this.onApplyPromo()}
                                                                >
                                                                    <a className="text-white" >
                                                                        Apply
                                                                    </a>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className="col-md-4 ml-auto mb-2 mt-2">
                                                    <div className="row"><div className="col-md-12 pl-0">
                                                        <div className="col">
                                                            <label>Promo Code</label>
                                                        </div>
                                                    </div>
                                                        <div className="d-flex">
                                                            <input type="text" className="form-control rounded-0" style={{ marginRight: '5px' }}
                                                                disabled={isPromoApply} value={promoCode} onChange={(e) => this.setState({ promoCode: e.target.value })}
                                                            />
                                                            {isPromoApply ?
                                                                <button className="btn btn-primary rounded-0"
                                                                    onClick={() => this.onCancelPromo()}
                                                                >
                                                                    <a className="" >
                                                                        Back
                                                                    </a>
                                                                </button>
                                                                :
                                                                <button className="btn btn-primary rounded-0"
                                                                    onClick={() => this.onApplyPromo()}
                                                                >
                                                                    <a className="text-white" >
                                                                        Apply
                                                                    </a>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div> */}

                                                <div className="row mt-4">
                                                    <div className="col-md-4">
                                                        <div className="row mb-3">
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <h5 className="mb-0">Visitor Registration Charges</h5>
                                                                <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{visitorCharges}</h5>
                                                            </div>
                                                            <div className="row" style={{ paddingRight: 0, textAlign: 'left' }}>
                                                                {console.log('paymentDatesList', paymentDatesList[0])}
                                                                {/* {paymentDatesList.length > 0 && paymentDatesList.map((item, i) => (
                                                                    <div className="d-flex justify-content-between" style={{ padding: 0 }}>
                                                                        <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                            <>{item2}
                                                                                {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                &nbsp;
                                                                            </>))})</p>
                                                                    </div>
                                                                ))} */}
                                                                <strong onClick={() => this.setState({ isOpen4: true })} className="text-primary" style={{ cursor: 'pointer' }}>(Click here to view Visit Days)</strong>
                                                            </div>
                                                        </div>
                                                        {promoCodeDiscount != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">Promo Code Discount({discountpercent}%)</h5>
                                                                    <h5 className="mb-0 text-danger">-{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.promoCodeDiscount}</h5>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {promoCodeDiscount != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">Total Taxable </h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totaltaxable}</h5>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {this.state.seminarCharges != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">Seminar Charges </h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.seminarCharges}</h5>
                                                                </div>
                                                                <div className="row" style={{ paddingRight: 0, textAlign: 'left' }}>
                                                                    {console.log('paymentDatesList', paymentDatesList[0])}
                                                                    {/* {paymentDatesList.length > 0 && paymentDatesList.map((item, i) => (
                                                                    <div className="d-flex justify-content-between" style={{ padding: 0 }}>
                                                                        <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                            <>{item2}
                                                                                {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                &nbsp;
                                                                            </>))})</p>
                                                                    </div>
                                                                ))} */}
                                                                    <strong onClick={() => this.setState({ isOpen5: true })} className="text-primary" style={{ cursor: 'pointer' }}>(Click here to view Seminar)</strong>
                                                                </div>
                                                                {/* <div className="col-xl-9" style={{ paddingRight: 0 }}>
                                                                    <div className="d-flex justify-content-between mb-2" style={{ padding: 0 }}>
                                                                        <strong>
                                                                            <p style={{ padding: 0, textAlign: 'left' }}>({seminarChargesShowList.map((item, i) => (
                                                                                <>
                                                                                    &nbsp;{item}{i != seminarChargesShowList.length - 1 && ','}  &nbsp;{i == 2 && <br></br>}
                                                                                </>
                                                                            ))})</p>
                                                                        </strong>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        )}
                                                        {/* {isParkingAvailable && isCarParking != 0 && parkingCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="col-6">
                                                                        <h6>Parking Charges</h6>
                                                                    </div>
                                                                    <div className="col-6 text-end">
                                                                        <h6>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{isCarParking ? parkingCharges : 0}</h6>
                                                                    </div>
                                                                </div>
                                                            )} */}

                                                        {this.state.CGST != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">CGST</h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.CGST}</h5>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {this.state.SGST != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">SGST</h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.SGST}</h5>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {this.state.IGST != 0 && (
                                                            <div className="row mb-2">
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <h5 className="mb-0">IGST</h5>
                                                                    <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.IGST}</h5>
                                                                </div>
                                                            </div>
                                                        )}


                                                        <div className="row mt-n2">
                                                            <div className="col-md-12">
                                                                <hr />
                                                            </div>
                                                        </div>
                                                        <div className="row  " >
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>Total Charges</h6>
                                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totalCharges}</h6>
                                                            </div>
                                                        </div>

                                                        {/* <div className="row border-top pt-2 mt-2 align-items-start">
                                                                
                                                                <div className="col-6">
                                                                    <h5>Total Charges</h5>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h5>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{totalCharges}</h5>
                                                                </div>
                                                            </div> */}
                                                    </div>
                                                </div>
                                                {/* <div className="row" >
                                                    <div style={{ textAlign: 'left' }} className="col-md-4 mt-2">
                                                        <label>Remark</label>
                                                        <textarea value={this.state.remark} className="form-control" onChange={(e) => this.setState({ remark: e.target.value })}>

                                                        </textarea>
                                                    </div>
                                                </div> */}
                                            </div>}

                                        </div>}
                                        <div className="main-container m-3">
                                            <div className="mt-1 mb-4 d-flex">
                                                <a
                                                    className="btn btn-aqua me-2"
                                                    type="submit"
                                                    onClick={(e) => this.onPrevClick(e)}
                                                >
                                                    Previous
                                                </a> {true ? <div>  <button type="btn" class="btn btn-aqua"
                                                    onClick={(e) => this.togglePGCharges(1)}
                                                // onClick={(e) => sessionStorage.getItem("countryId") == 91 ? this.togglePGCharges(1) : this.props.navigate('/visitorthankyou')}

                                                // disabled={toPay <= 0 || toPay == '' || toPay == null || paymentType == ''} 
                                                // Sstyle={{ border: 'none', borderRadius: '2px', scale: '1.2' }}
                                                >
                                                    {/* <span style={{ color: 'black', padding: "4px 20px", fontWeight: 500, }}> */}
                                                    Submit
                                                    {/* </span> */}
                                                    {/* {!isPaid && isCarParking == 1 ? 'Make Payment' : 'Update'} */}

                                                </button></div> :
                                                    <form onSubmit={(e) => this.onPreviewSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                                        // action={paymentPortalLink}
                                                        action={this.state.paymentLink}

                                                    >

                                                        {/* <input type="hidden" id="encRequest" name="encRequest"
                                                        value={encPayload} />
                                                    <input type="hidden" name="access_code" id="access_code"
                                                        value={paymentAccessCode} /> */}
                                                        <button type="btn" class="btn btn-aqua">
                                                            Submit

                                                        </button>
                                                    </form>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this Document?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.promocodeModel} onRequestClose={() => this.setState({ promocodeModel: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Previous</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ promocodeModel: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">If you go back then in that case your promo code will be removed and you will have to enter promo code again</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.props.navigate('/visitorindustrysegment', { state: { is_previous: true } })}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isOpen4} onRequestClose={() => this.setState({ isOpen4: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content visit-days">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Visit Days</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen4: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" >
                                                        Name
                                                    </th>
                                                    <th className="text-center">Visit Days</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentDatesList.length > 0 ? paymentDatesList.map((item, index) => (
                                                        <tr key={Math.random()}>
                                                            <td className="text-center">{item.name}</td>
                                                            <td className="text-center">{item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                <>{item2}
                                                                    {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                    &nbsp;
                                                                </>
                                                            ))}</td>
                                                            {/* <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                <>{item2}
                                                                    {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                    &nbsp;
                                                                </>))})</p> */}

                                                        </tr>
                                                    )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={() => this.setState({ isOpen4: false })}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isOpen5} onRequestClose={() => this.setState({ isOpen5: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content visit-days">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Visit Days</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen5: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" >
                                                        Name
                                                    </th>
                                                    <th className="text-center">Seminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    seminarChargesShowList.length > 0 ? seminarChargesShowList.map((item, index) => (
                                                        item.displaySeminar != undefined ? item.displaySeminar.length > 0 && <tr key={Math.random()}>
                                                            <td className="text-center">{item.name}</td>
                                                            <td >{item != undefined && item.displaySeminar.length > 0 && item.displaySeminar.map((item2, i2) => (
                                                                <>{item2}
                                                                    {item.displaySeminar != undefined ? i2 != item.displaySeminar.length - 1 ? ',' : '' : ''}
                                                                    &nbsp;
                                                                    <br></br>
                                                                </>
                                                            ))}</td>
                                                            {/* <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                <>{item2}
                                                                    {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                    &nbsp;
                                                                </>))})</p> */}

                                                        </tr> : <></>
                                                    )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={() => this.setState({ isOpen5: false })}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={pgViewChargesModal}
                    onRequestClose={() => this.setState({ pgViewChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-success text-center fw-bold w-100">
                                    Bank Charges
                                </h4>
                            </div>
                            <div className="row m-3" >
                                <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mg-b-0">
                                        <thead>
                                            <tr>
                                                <th>Payment Mode</th>
                                                <th>Bank Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody id="myTable">
                                            {this.state.pgViewChargesFillList.length > 0 ? (
                                                this.state.pgViewChargesFillList.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                        <td>{data.Value}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td colSpan={6}>No Records Found...</td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1 col-3">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.onPreviewSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                        value={encPayload} />
                                                    <input type="hidden" name="access_code" id="access_code"
                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={pgViewAddChargesModal}
                    onRequestClose={() => this.setState({ pgViewAddChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-white text-center fw-bold w-100">
                                    Additional Charges
                                </h4>
                            </div>
                            <div className="row mb-3" >
                                <div className="containerfluid m-0  px-3 ">
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg d-flex ps-3">
                                                <p className="mb-0">
                                                    Choose Payment Currency<span className="text-red">*</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ms-3" >
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={this.state.isPaidByUSD}
                                                checked={this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: true, toShow: totalCharges })}
                                            />
                                            Pay in USD ($)
                                        </label>
                                    </div>
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={!this.state.isPaidByUSD}
                                                checked={!this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: false, toShow: (totalCharges * this.state.conversionRate).toFixed(2) })}
                                            />
                                            Pay in INR (₹)
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-3" >
                                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p> */}
                                {/* <>“”</> */}
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Visitor Registration Charges</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.toShow}</h5>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Additional charges ({this.state.additionalChargesUSDper}%)</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? (this.state.additionalChargesUSD) : ((this.state.additionalChargesUSDper / 100) * this.state.toShow).toFixed(2)}</h5>
                                    </div>
                                </div>
                                {this.state.IGST != 0 && (
                                    <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">Total Payable</h5>
                                            <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2)}</h5>
                                        </div>
                                    </div>
                                )}
                                <p className='mt-2 '><strong>Kindly note that an additional {this.state.additionalChargesUSDper}% charge towards currency conversion will be applicable at the time of final payment as you proceed to the payment gateway.</strong></p>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.onPreviewSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            className="pay-btn-form"
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                        value={encPayload} />
                                                    <input type="hidden" name="access_code" id="access_code"
                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isForeignVisitorPop} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-Primary"></h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <strong>
                                        Payments can currently be made only using Visa, Master Card, and RuPay cards issued by non-Indian banks.                                    </strong>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            this.togglePGCharges(2)
                                            this.setState({ isForeignVisitorPop: false })
                                        }
                                        }
                                    >Ok</button>
                                    <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
                {console.log('daysList', this.state.interestList)}
            </>

        )
    }
}
export default withRouter(connect(null, {
    fill_action, combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, payment_action, sendPaymentForm_action,
    deleteVisaDoc_action, getVisitorRegistrationCredentials_action, getDrawerDetails_action, getVisitorPreviewDetails_action,
    visitorPreviewSubmit_action, verifyVisitorPromoCode_action
})(Visitor_Preview))

